/*
    This is a NON minified version of Booster's Javascript
    This is NOT the default javascript being served
    By default BoosterTheme will load "booster.min.js" which can be found in /assets
    In order to minify this file and replace "booster.min.js" you can use ANY Javascript minifier as this code does NOT use Liquid
*/

function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

function getRandomInt(minimum, maximum){
    return Math.floor(Math.random() * (maximum - minimum + 1) + minimum)
}

function closeModal(event, modal = false){
    if(!modal) modal = event.currentTarget.closest('[data-bstr-modal]') || event.currentTarget.closest('.modal')
    modal.style.display = "none"
}

const isUndefined = (e)=>typeof e == "undefined"

Element.prototype.closestEl = function (e) {
	for (var t = this.parentElement; t;) {
		if (t.matches(e)) return t;
		var r = t.querySelectorAll(e);
		for (let i = 0, mi = r.length; i < mi; ++i)
			if (null != r[i] && r[i] != this) return r[i];
		t = t.parentElement
	}
	return null
};

const BstrDummyClass = new Proxy(new (class BstrEmptyClass{}), {
    get(target, name){
      return ()=>{}
    }
})

const __bstrInitClass = (cls, ...args) => {
    try{
        return new cls(...args)
    }catch(err){
        console.debug("[Booster Class Init] ", err)
    }
}

class BstrStore {
    constructor(){}

    get(key, def = false, parse = true){
        const value = localStorage.getItem(key);
        if(!value) return def
        if(!parse) return value

        try{
            const json = JSON.parse(value);
            if(typeof json.data == null || typeof json.exp == null || json.storeRef !== "bstr") return json

            if(json.exp && json.exp < Date.now()){
                localStorage.removeItem(key);
                return def;
            }

            return json.data;
        }catch(err){
            return def;
        }
    }

    set(key, value, exp = false){
        const expiration =  (exp && !isNaN(exp)) ? Date.now() + (exp * 60000) : false;
        const dataToStore = {data: value, storeRef: 'bstr', exp: expiration};

        localStorage.setItem(key, JSON.stringify(dataToStore));
        return true;
    }
}

class BstrAsync{
    constructor({events}){
        this.events = events
    }

    async load({url, section = false, selector = 'body', json = false}){
        if(section) url.searchParams.set('section_id', section)
        let r = await fetch(url.toString())
        if(!r.ok) return {}
        try{
            let raw = await r.text()
            let dom = new DOMParser().parseFromString(raw, 'text/html')
            if(!json) return {html: dom.querySelector(selector).innerHTML, parser: dom}
            try{
                return {html: dom.querySelector(selector).innerHTML, parser: dom, json: JSON.parse(dom.querySelector(json).innerText)};
            }catch(err){
                console.debug(err)
                return {html: dom.querySelector(selector).innerHTML, parser: dom, json: false}
            }       
        }catch(err){
            console.debug(err)
            return {}
        }
    }

    async getUpsell(product){
        let {html} = await this.load({url: new URL(window.location.origin + product), section: 'api__upsell', selector: '.shopify-section'})
        return html
    }
}

class BstrCart{
    constructor({events, basync}){
        this.events = events;
        this.basync = basync;
        this.qtytimer = null;
        this.queue = [];
        this.awaitingSuccess = [];
        this.listeners = [];
        this.preventFocus = false;
        this.minicart = {lastUpdate: 0};
        this.cartSuccessConfig = {action: _settings.cartAction};
        this.cartSuccessInfoTemplate = document.querySelector('.add-to-cart__success--single-current') && document.querySelector('.add-to-cart__success--single-current').innerHTML || false;
        let carts = document.querySelectorAll('[data-cart-container]');
        for(let i = 0, maxi = carts.length; i < maxi; ++i){
            this.addListener(carts[i]);
        }
        this.dispatchListeners();
        this.bindXHRFetch();
        this.minicartURL();
    }

    bindXHRFetch(){
        const self = this;
        const open = window.XMLHttpRequest.prototype.open;
        function openReplacement() {
                this.addEventListener("load", function (){
                        try{
                            let url = new URL(this._url);
                            if(url.origin == window.location.origin){
                                if([
                                    `${window.Shopify.routes.root}cart/add.js`,
                                    `${window.Shopify.routes.root}cart/update.js`,
                                    `${window.Shopify.routes.root}cart/change.js`,
                                    `${window.Shopify.routes.root}cart/clear.js`,
                                    `${window.Shopify.routes.root}cart/add`,
                                ].includes(url.pathname)){
                                    self.dispatchListeners({change: true});
                                }
                            }
                        }catch(err){
                            try{
                                if([
                                    `${window.Shopify.routes.root}cart/add.js`,
                                    `${window.Shopify.routes.root}cart/update.js`,
                                    `${window.Shopify.routes.root}cart/change.js`,
                                    `${window.Shopify.routes.root}cart/clear.js`,
                                    `${window.Shopify.routes.root}cart/add`,
                                ].includes(this._url)){
                                    self.dispatchListeners({change: true});
                                }
                            }catch(error){
                                console.log('[BOOSTER THEME] Invalid URL format caught in XHR.')
                            }
                        }
                    }
                );
            return open.apply(this, arguments);
        }
        window.XMLHttpRequest.prototype.open = openReplacement;

        (function(ns, fetch) {
            if (typeof fetch !== 'function') return;
            ns.fetch = function() {
                const response = fetch.apply(this, arguments);
                response.then(res => {
                    try{
                        let url = new URL(res.url);
                        if(url.origin == window.location.origin){
                            if([
                                `${window.Shopify.routes.root}cart/add.js`,
                                `${window.Shopify.routes.root}cart/update.js`,
                                `${window.Shopify.routes.root}cart/change.js`,
                                `${window.Shopify.routes.root}cart/clear.js`,
                                `${window.Shopify.routes.root}cart/add`,
                            ].includes(url.pathname)){
                                self.dispatchListeners({change: true});
                            }
                        }
                    }
                    catch(err){
                    /*    console.log('[BOOSTER THEME] Invalid URL format caught in fetch.')    */
                    }
                });
                return response;
            }
        }(window, window.fetch))

        window.addEventListener('storage', (e)=>{
            if(e.key != 'bstr:cart:update') return
            if(bstore.get('bstr:cart:update', 0) > self.minicart.lastUpdate){
                this.dispatchListeners()
            }
        })
    }

    minicartURL(){
      let url = new URL(document.URL);
      let open = url.searchParams.get('minicartOpen') ? url.searchParams.get('minicartOpen') : false;
      if (open) {
        history.replaceState({}, '', url.origin);
        this.minicartOpen()
/*
        history.replaceState({}, '', url.origin);
        let checked = document.querySelectorAll('[data-minicart-input]:checked')
        if(checked.length) return
        let mi = document.querySelectorAll('[data-minicart-input]')
        for(let m of mi){
            var event = new Event('change');
            m.checked = true;
            m.dispatchEvent(event);
        }
*/
      }

    }

    minicartOpen(){
      openModal();  
/*
        let checked = document.querySelectorAll('[data-minicart-input]:checked')
        if(checked.length) return
        let mi = document.querySelectorAll('[data-minicart-input]')
        for(let m of mi){
            let l = m.closestEl('.minicart__label')
         // if(l && l.clientHeight > 0 && l.clientWidth > 0) return m.checked = true
            if(l && l.clientHeight > 0 && l.clientWidth > 0) {
                var event = new Event('change');
                m.checked = true;
                m.dispatchEvent(event);
                return;
            }
        }
*/
    }

    minicartHide(){
      hideModal();  
/*
        let checked = document.querySelectorAll('[data-minicart-input]:checked')
     // for(let c of checked){ c.checked = false; }
        for(let c of checked){ 
          var event = new Event('change');
          c.checked = false;
          c.dispatchEvent(event);
        }
*/
    }

    async clear(){
        let r = await fetch(`${window.Shopify.routes.root}cart/clear.js`)
        if(!r.ok) return
        this.events.trigger('booster:cart:clear')
    }

    addListener(target, data){
        let settingsData = target.dataset.cartSettings.split(',');
        let settings = {};
        for(let i = 0, maxi = settingsData.length; i < maxi; ++i){
            let key = settingsData[i];
            settings[key] = target.querySelector(`[data-${key}]`);
        }
        this.listeners.push(
            {target: target, settings: settings}
        )
    }

    minicartHandler(time){
        for(let i = 0, maxi = this.listeners.length; i < maxi; ++i){
            let target = this.listeners[i];
            let keys = Object.keys(target.settings);
            for(let j = 0, maxj = keys.length; j < maxj; ++j){
                let key = keys[j];
                
                if(!target.settings[key]){
                    continue
                }
                if(target.settings[key].dataset.lastUpdate > time){
                    continue;
                }
                if(typeof events != "undefined" && events.indexOf(key) == -1){
                    continue;
                }

                switch(key){
                    case 'count':
                    target.settings[key].innerText = this.minicart.data.item_count;
                    break;
                    case 'product-list':
                    target.settings[key].innerHTML = this.minicart.data.html;
                    break;
                    case 'total':
                    target.settings[key].innerText = this.minicart.data.total;
                    break;
                }
                target.settings[key].dataset.lastUpdate = time;
            }
        }
    }

    async dispatchListeners({change = false} = {}){
        let self = this;
        let time = Date.now();

        if(time > self.minicart.lastUpdate){
            let cartData = await (await fetch(`${window.Shopify.routes.root}?section_id=api__minicart`, {headers: { 'Pragma': 'no-cache', 'Cache-Control': 'no-cache, no-store, must-revalidate', 'Expires': 0 }})).text();
            let div = document.createElement('div');
            div.innerHTML = cartData;

            this.minicart = {lastUpdate: time, data: JSON.parse(div.innerText)};
            this.minicart.data.items = JSON.parse(this.minicart.data.items);
            this.events.trigger('booster:cart:update', this.minicart, true);
        }

        this.minicartHandler(time);
        if(change) localStorage.setItem('bstr:cart:update', time)
        this.events.trigger('booster:content:update', {trigger: 'minicart'})

        while(this.awaitingSuccess.length){
            this.success(this.awaitingSuccess.pop());
        }
    }

    quantityHandler(event, incr, updateCart = true){
        event.preventDefault();
        let qtyInput = event.target.parentElement.querySelector('[data-qty-input]');
        if(incr){
            if(!isNaN(parseInt(qtyInput.max)) && parseInt(qtyInput.value) >= qtyInput.max) return this.error('Maximum quantity of 99 reached!')
            qtyInput.value++;
        } else {
            if(parseInt(qtyInput.value) <= 0 || !updateCart && parseInt(qtyInput.value) == 1) return false
            --qtyInput.value;
        }
        if(!updateCart) return true

        clearTimeout(this.qtytimer);
        this.qtytimer = setTimeout(function () {
          return qtyInput.onchange({target: qtyInput});
        }, 350);
    }

    addToQueue(data){
        this.queue.push(data)
        if(this.queue.length > 1) return
        this.checkQueue()
    }

    addToCartIU(){
        let selected = document.querySelectorAll('input.inline-upsell__toggle:checked');
        let data = {items: []}
        for(let i = 0, maxi = selected.length; i < maxi; ++i){
            let id = document.getElementById(selected[i].dataset.for).value;
            data.items.push({quantity: 1, id: id});
        }
        this.addToCartJSON(false, data)
    }

    addToCart(event = false, form = false) {

        if(!event && !form) return
        let target = false;
        if(event){ target = event.currentTarget; event.preventDefault(); event.stopImmediatePropagation() }
        if(!form) form = target.closest('form')
        if(target){
            target.disabled = true
            target.querySelector('[data-button-back]').innerHTML = target.querySelector('[data-button-text]').innerHTML
            target.querySelector('[data-button-text]').innerHTML = _bstrLocale.buttons.adding
        }

        let {prevent} = this.events.trigger('booster:cart:b*add', {form, target})

        if(prevent){
            if(target){
                target.disabled = false
                target.querySelector('[data-button-text]').innerHTML = target.dataset.originalText
            }
            return
        }
        this.addToQueue({form, target})
    }

    addToCartJSON(event = false, json = {items: []}){
        let target = false;
        if(event) target = event.currentTarget
        if(target){
            target.disabled = true
            target.querySelector('[data-button-back]').innerHTML = target.querySelector('[data-button-text]').innerHTML
            target.querySelector('[data-button-text]').innerHTML = _bstrLocale.buttons.adding
        }
        let {prevent} = this.events.trigger('booster:cart:b*add', {json, target})
        if(prevent){
            if(target){
                target.disabled = false
                target.querySelector('[data-button-text]').innerHTML = target.dataset.originalText
            }
            return
        }
        this.addToQueue({target, json})
    }

    async removeFromCart(target = false, id){
        let mentry = target ? target.closest('.minicart__entry') : false;
        if(target) target.disabled = true;
        if(mentry) mentry.style.opacity = '0.5'
        let res = await (await fetch(`${window.Shopify.routes.root}cart/change.js`, {method: 'POST', headers: {'Content-Type': 'application/json' }, body: JSON.stringify({quantity: 0, id: id})})).json();
        if(!isUndefined(res.status) && res.status != "success"){
            if(target) target.disabled = false
            if(mentry) mentry.style.opacity = '1'
        /*  return this.error(res)  */
        }
        else {
          setTimeout(function () {
            BoosterTheme.cart.minicartOpen()
          }, 350);
        }
        return true;
    }

    async updateQuantity(event, variant, quantity, forced = false){
        let {target} = event
        if(!forced){
            variant = target.dataset.variantId;
            quantity = target.value;
        }
        let res = await (await fetch(`${window.Shopify.routes.root}cart/change.js`, {method: 'POST', headers: {'Content-Type': 'application/json' }, body: JSON.stringify({quantity: quantity, id: variant})})).json();
        if(!isUndefined(res.status) && res.status != "success"){
        /*  return this.error(res)  */
        }
        else {
          setTimeout(function () {
            BoosterTheme.cart.minicartOpen()
          }, 350);
        }
        return true;
    }

    checkQueue(){
        if(this.queue.length){
            this.processQueue(this.queue.shift());
        }
    }

    async processQueue(data) {

        let {target, form, json} = data;

/*      let fconfig = form ? {method: 'POST', headers: {'Content-Type': 'multipart/form-data'}, body: new URLSearchParams(new FormData(form))} : {method: 'POST', body: JSON.stringify(json), headers: {'Content-Type': 'application/json'}};      */
        let fconfig = form ? {method: "post", body: new FormData(form)} : {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(json)};
        let res = await (await fetch(`${window.Shopify.routes.root}cart/add.js`, fconfig)).json();

        if(target){
            target.disabled = false
            target.querySelector('[data-button-text]').innerHTML = target.querySelector('[data-button-back]').innerHTML
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
         'event': 'Add To Cart',
          'items': [
            {
              'id': res.id,
              'name': res.title,
              'brand': res.vendor,
              'price' : res.price * 0.01,
              'variant' : res.variant_title
            }
          ]
         });

        typeof res.status != "undefined" && res.status != "success" ? this.error(res) : this.awaitingSuccess.push(res)

        this.checkQueue()

    }

    async renderModal(item, render_upsell = false){
        let prevent_modal = this.events.trigger('booster:cart:b*modal', {item, cart: this.minicart, will_upsell: render_upsell})
        if(prevent_modal.prevent) return
        let container = document.getElementById('checkout--success');
        let modal = container.closest('.modal');
        let image = item.image;
        let title = item.product_title;
        let variant = '';
        let total = this.minicart.data.total;
        let itemCountInt = this.minicart.data.item_count;
        let itemCount = itemCountInt + ' item' + (itemCountInt > 1 ? 's' : '');
        if(!item.product_has_only_default_variant) variant = item.variant_title;
        let productInfo = container.querySelector('.add-to-cart__success--single');
        const $pi = (q)=>productInfo.querySelector(q)
        let imgc = $pi('.add-to-cart__success--single-img');
        if(image != null){
            imgc.src = image
            imgc.style.display = "block"
        } else {
            imgc.style.display = "none"
        }
        $pi('.add-to-cart__success--single-title').innerText = title;
        $pi('.add-to-cart__success--single-variation').innerText = variant;
        let template = this.cartSuccessInfoTemplate.replace('%total%', total).replace('%itemCount%', itemCount);
        $pi('.add-to-cart__success--single-current').innerHTML = template;
        let prevent_upsell = this.events.trigger('booster:cart:b*upsell', {item, cart: this.minicart})
        if(render_upsell && !prevent_upsell.prevent){
          let upsell = await this.basync.getUpsell(item.url);
          let upsellContainer = container.querySelector('.add-to-cart__success--upsell');
          upsellContainer.style.display = "none"
          if(upsell.trim() != ''){
              let modal = document.getElementById('quickbuy__modal')
              if(modal) modal.style.display = "none"
              upsellContainer.innerHTML = upsell
              upsellContainer.style.display = "flex"
              this.events.trigger('booster:cart:upsell', {html: upsellContainer, items: false, item, cart: this.minicart})
          }
        }
        modal.style.display = "block";
        this.events.trigger('booster:content:update', {trigger: 'upsell'})
    }

    success(data){
        let config = this.cartSuccessConfig;
        let item = data.items && data.items[0] || data
        this.events.trigger('booster:cart:add', {item})
        if(config.action == 'cart') return window.location = `${window.Shopify.routes.root}cart`;
        if(config.action == 'checkout') return window.location = `${window.Shopify.routes.root}checkout`;
        if(config.action == 'message') return this.events.trigger('booster:notify', {type: 'success', message: 'Product added to cart successfully.'});
        if(config.action == 'minicart') return this.minicartOpen();
        this.renderModal(item, config.action == 'upsell')
      }

    error(data){
    /*  console.error('Error trying to add product:\n', data)  */
        return this.events.trigger('booster:notify', {type: 'error', message: data})
    }
}

class BstrCurrency{
    constructor({events}){
        this.moneyFormats = { USD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} USD" }, EUR: { money_format: "&euro;{{amount}}", money_with_currency_format: "&euro;{{amount}} EUR" }, GBP: { money_format: "&pound;{{amount}}", money_with_currency_format: "&pound;{{amount}} GBP" }, CAD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} CAD" }, ALL: { money_format: "Lek {{amount}}", money_with_currency_format: "Lek {{amount}} ALL" }, DZD: { money_format: "DA {{amount}}", money_with_currency_format: "DA {{amount}} DZD" }, AFN: { money_format: "&#65;&#102; {{amount}}", money_with_currency_format: "&#65;&#102; {{amount}} AFN" }, AOA: { money_format: "Kz{{amount}}", money_with_currency_format: "Kz{{amount}} AOA" }, ARS: { money_format: "${{amount_with_comma_separator}}", money_with_currency_format: "${{amount_with_comma_separator}} ARS" }, AMD: { money_format: "{{amount}} AMD", money_with_currency_format: "{{amount}} AMD" }, AWG: { money_format: "Afl{{amount}}", money_with_currency_format: "Afl{{amount}} AWG" }, AUD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} AUD" }, BBD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} Bds" }, AZN: { money_format: "m.{{amount}}", money_with_currency_format: "m.{{amount}} AZN" }, BDT: { money_format: "Tk {{amount}}", money_with_currency_format: "Tk {{amount}} BDT" }, BSD: { money_format: "BS${{amount}}", money_with_currency_format: "BS${{amount}} BSD" }, BHD: { money_format: "{{amount}}0 BD", money_with_currency_format: "{{amount}}0 BHD" }, BYN: { money_format: "Br {{amount}}", money_with_currency_format: "Br {{amount}} BYN" }, BYR: { money_format: "Br {{amount}}", money_with_currency_format: "Br {{amount}} BYR" }, BZD: { money_format: "BZ${{amount}}", money_with_currency_format: "BZ${{amount}} BZD" }, BTN: { money_format: "Nu {{amount}}", money_with_currency_format: "Nu {{amount}} BTN" }, BAM: { money_format: "KM {{amount_with_comma_separator}}", money_with_currency_format: "KM {{amount_with_comma_separator}} BAM" }, BRL: { money_format: "R$ {{amount_with_comma_separator}}", money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL" }, BOB: { money_format: "Bs{{amount_with_comma_separator}}", money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB" }, BMD: { money_format: "&#36; {{amount}}", money_with_currency_format: "&#36; {{amount}} BMD" }, BIF: { money_format: "&#70;&#66;&#117; {{amount}}", money_with_currency_format: "&#70;&#66;&#117; {{amount}} BIF" }, BWP: { money_format: "P{{amount}}", money_with_currency_format: "P{{amount}} BWP" }, BND: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} BND" }, CVE: { money_format: "&#36; {{amount}}", money_with_currency_format: "&#36; {{amount}} CVE" }, KMF: { money_format: "&#67;&#70; {{amount}}", money_with_currency_format: "&#67;&#70; {{amount}} KMF" }, CUC: { money_format: "{{amount}}", money_with_currency_format: "{{amount}} CUC" }, CUP: { money_format: "{{amount}}", money_with_currency_format: "{{amount}} CUP" }, CDF: { money_format: "&#70;&#67; {{amount}}", money_with_currency_format: "&#70;&#67; {{amount}} CDF" }, DJF: { money_format: "&#70;&#100;&#106; {{amount}}", money_with_currency_format: "&#70;&#100;&#106; {{amount}} DJF" }, ERN: { money_format: "{{amount}}", money_with_currency_format: "{{amount}} ERN" }, FKP: { money_format: "&#163; {{amount}}", money_with_currency_format: "&#163; {{amount}} FKP" }, GIP: { money_format: "&#163; {{amount}}", money_with_currency_format: "&#163; {{amount}} GIP" }, XAU: { money_format: "{{amount}}", money_with_currency_format: "{{amount}} XAU" }, GGP: { money_format: "{{amount}}", money_with_currency_format: "{{amount}} GGP" }, GNF: { money_format: "&#70;&#71; {{amount}}", money_with_currency_format: "&#70;&#71; {{amount}} GNF" }, HTG: { money_format: "&#71; {{amount}}", money_with_currency_format: "&#71; {{amount}} HTG" }, XDR: { money_format: "{{amount}}", money_with_currency_format: "{{amount}} XDR" }, IDR: { money_format: "{{amount_with_comma_separator}} IDR", money_with_currency_format: "Rp {{amount_with_comma_separator}} IDR" }, IQD: { money_format: "&#1593;.&#1583; {{amount}}", money_with_currency_format: "&#1593;.&#1583; {{amount}} IQD" }, IMP: { money_format: "{{amount}}", money_with_currency_format: "{{amount}} IMP" }, LAK: { money_format: "&#8365; {{amount}}", money_with_currency_format: "&#8365; {{amount}} LAK" }, LSL: { money_format: "&#76; {{amount}}", money_with_currency_format: "&#76; {{amount}} LSL" }, LRD: { money_format: "&#36; {{amount}}", money_with_currency_format: "&#36; {{amount}} LRD" }, LYD: { money_format: "&#1604;.&#1583; {{amount}}", money_with_currency_format: "&#1604;.&#1583; {{amount}} LYD" }, MWK: { money_format: "&#77;&#75; {{amount}}", money_with_currency_format: "&#77;&#75; {{amount}} MWK" }, MRO: { money_format: "&#85;&#77; {{amount}}", money_with_currency_format: "&#85;&#77; {{amount}} MRO" }, KPW: { money_format: "&#8361; {{amount}}", money_with_currency_format: "&#8361; {{amount}} KPW" }, OMR: { money_format: "{{amount_with_comma_separator}} OMR", money_with_currency_format: "{{amount_with_comma_separator}} OMR" }, PAB: { money_format: "&#66;&#47;&#46; {{amount}}", money_with_currency_format: "&#66;&#47;&#46; {{amount}} PAB" }, SHP: { money_format: "&#163; {{amount}}", money_with_currency_format: "&#163; {{amount}} SHP" }, SVC: { money_format: "&#36; {{amount}}", money_with_currency_format: "&#36; {{amount}} SVC" }, SLL: { money_format: "&#76;&#101; {{amount}}", money_with_currency_format: "&#76;&#101; {{amount}} SLL" }, XAG: { money_format: "{{amount}}", money_with_currency_format: "{{amount}} XAG" }, SBD: { money_format: "&#36; {{amount}}", money_with_currency_format: "&#36; {{amount}} SBD" }, SOS: { money_format: "&#83; {{amount}}", money_with_currency_format: "&#83; {{amount}} SOS" }, SDG: { money_format: "&#163; {{amount}}", money_with_currency_format: "&#163; {{amount}} SDG" }, SRD: { money_format: "&#36; {{amount}}", money_with_currency_format: "&#36; {{amount}} SRD" }, SZL: { money_format: "&#76; {{amount}}", money_with_currency_format: "&#76; {{amount}} SZL" }, TJS: { money_format: "&#84;&#74;&#83; {{amount}}", money_with_currency_format: "&#84;&#74;&#83; {{amount}} TJS" }, TOP: { money_format: "&#84;&#36; {{amount}}", money_with_currency_format: "&#84;&#36; {{amount}} TOP" }, TMT: { money_format: "&#109; {{amount}}", money_with_currency_format: "&#109; {{amount}} TMT" }, UZS: { money_format: "&#1083;&#1074; {{amount}}", money_with_currency_format: "&#1083;&#1074; {{amount}} UZS" }, YER: { money_format: "&#65020; {{amount}}", money_with_currency_format: "&#65020; {{amount}} YER" }, BGN: { money_format: "{{amount}} Đ»Đ˛", money_with_currency_format: "{{amount}} Đ»Đ˛ BGN" }, MMK: { money_format: "K{{amount}}", money_with_currency_format: "K{{amount}} MMK" }, KHR: { money_format: "KHR{{amount}}", money_with_currency_format: "KHR{{amount}}" }, KYD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} KYD" }, XAF: { money_format: "FCFA{{amount}}", money_with_currency_format: "FCFA{{amount}} XAF" }, CLP: { money_format: "${{amount_no_decimals}}", money_with_currency_format: "${{amount_no_decimals}} CLP" }, CNY: { money_format: "&#165;{{amount}}", money_with_currency_format: "&#165;{{amount}} CNY" }, COP: { money_format: "${{amount_with_comma_separator}}", money_with_currency_format: "${{amount_with_comma_separator}} COP" }, CRC: { money_format: "&#8353; {{amount_with_comma_separator}}", money_with_currency_format: "&#8353; {{amount_with_comma_separator}} CRC" }, HRK: { money_format: "{{amount_with_comma_separator}} kn", money_with_currency_format: "{{amount_with_comma_separator}} kn HRK" }, CZK: { money_format: "{{amount_with_comma_separator}} K&#269;", money_with_currency_format: "{{amount_with_comma_separator}} K&#269;" }, DKK: { money_format: "{{amount_with_comma_separator}}", money_with_currency_format: "kr.{{amount_with_comma_separator}}" }, DOP: { money_format: "RD$ {{amount}}", money_with_currency_format: "RD$ {{amount}}" }, XCD: { money_format: "${{amount}}", money_with_currency_format: "EC${{amount}}" }, EGP: { money_format: "LE {{amount}}", money_with_currency_format: "LE {{amount}} EGP" }, ETB: { money_format: "Br{{amount}}", money_with_currency_format: "Br{{amount}} ETB" }, XPF: { money_format: "{{amount_no_decimals_with_comma_separator}} XPF", money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} XPF" }, FJD: { money_format: "${{amount}}", money_with_currency_format: "FJ${{amount}}" }, GMD: { money_format: "D {{amount}}", money_with_currency_format: "D {{amount}} GMD" }, GHS: { money_format: "GH&#8373;{{amount}}", money_with_currency_format: "GH&#8373;{{amount}}" }, GTQ: { money_format: "Q{{amount}}", money_with_currency_format: "{{amount}} GTQ" }, GYD: { money_format: "G${{amount}}", money_with_currency_format: "${{amount}} GYD" }, GEL: { money_format: "{{amount}} GEL", money_with_currency_format: "{{amount}} GEL" }, HNL: { money_format: "L {{amount}}", money_with_currency_format: "L {{amount}} HNL" }, HKD: { money_format: "${{amount}}", money_with_currency_format: "HK${{amount}}" }, HUF: { money_format: "{{amount_no_decimals_with_comma_separator}}", money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} Ft" }, ISK: { money_format: "{{amount_no_decimals}} kr", money_with_currency_format: "{{amount_no_decimals}} kr ISK" }, INR: { money_format: "Rs. {{amount}}", money_with_currency_format: "Rs. {{amount}}" }, IDR: { money_format: "{{amount_with_comma_separator}}", money_with_currency_format: "Rp {{amount_with_comma_separator}}" }, ILS: { money_format: "{{amount}} NIS", money_with_currency_format: "{{amount}} NIS" }, JMD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} JMD" }, JPY: { money_format: "&#165;{{amount_no_decimals}}", money_with_currency_format: "&#165;{{amount_no_decimals}} JPY" }, JEP: { money_format: "&pound;{{amount}}", money_with_currency_format: "&pound;{{amount}} JEP" }, JOD: { money_format: "{{amount}}0 JD", money_with_currency_format: "{{amount}}0 JOD" }, KZT: { money_format: "{{amount}} KZT", money_with_currency_format: "{{amount}} KZT" }, KES: { money_format: "KSh{{amount}}", money_with_currency_format: "KSh{{amount}}" }, KWD: { money_format: "{{amount}}0 KD", money_with_currency_format: "{{amount}}0 KWD" }, KGS: { money_format: "Đ»Đ˛{{amount}}", money_with_currency_format: "Đ»Đ˛{{amount}}" }, LVL: { money_format: "Ls {{amount}}", money_with_currency_format: "Ls {{amount}} LVL" }, LBP: { money_format: "L&pound;{{amount}}", money_with_currency_format: "L&pound;{{amount}} LBP" }, LTL: { money_format: "{{amount}} Lt", money_with_currency_format: "{{amount}} Lt" }, MGA: { money_format: "Ar {{amount}}", money_with_currency_format: "Ar {{amount}} MGA" }, MKD: { money_format: "Đ´ĐµĐ˝ {{amount}}", money_with_currency_format: "Đ´ĐµĐ˝ {{amount}} MKD" }, MOP: { money_format: "MOP${{amount}}", money_with_currency_format: "MOP${{amount}}" }, MVR: { money_format: "Rf{{amount}}", money_with_currency_format: "Rf{{amount}} MRf" }, MXN: { money_format: "$ {{amount}}", money_with_currency_format: "$ {{amount}} MXN" }, MYR: { money_format: "RM{{amount}} MYR", money_with_currency_format: "RM{{amount}} MYR" }, MUR: { money_format: "Rs {{amount}}", money_with_currency_format: "Rs {{amount}} MUR" }, MDL: { money_format: "{{amount}} MDL", money_with_currency_format: "{{amount}} MDL" }, MAD: { money_format: "{{amount}} dh", money_with_currency_format: "Dh {{amount}} MAD" }, MNT: { money_format: "{{amount_no_decimals}} &#8366", money_with_currency_format: "{{amount_no_decimals}} MNT" }, MZN: { money_format: "{{amount}} Mt", money_with_currency_format: "Mt {{amount}} MZN" }, NAD: { money_format: "N${{amount}}", money_with_currency_format: "N${{amount}} NAD" }, NPR: { money_format: "Rs{{amount}}", money_with_currency_format: "Rs{{amount}} NPR" }, ANG: { money_format: "&fnof;{{amount}}", money_with_currency_format: "{{amount}} NA&fnof;" }, NZD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} NZD" }, NIO: { money_format: "C${{amount}}", money_with_currency_format: "C${{amount}} NIO" }, NGN: { money_format: "&#8358;{{amount}}", money_with_currency_format: "&#8358;{{amount}} NGN" }, NOK: { money_format: "kr {{amount_with_comma_separator}}", money_with_currency_format: "kr {{amount_with_comma_separator}} NOK" }, OMR: { money_format: "{{amount_with_comma_separator}} OMR", money_with_currency_format: "{{amount_with_comma_separator}} OMR" }, PKR: { money_format: "Rs.{{amount}}", money_with_currency_format: "Rs.{{amount}} PKR" }, PGK: { money_format: "K {{amount}}", money_with_currency_format: "K {{amount}} PGK" }, PYG: { money_format: "Gs. {{amount_no_decimals_with_comma_separator}}", money_with_currency_format: "Gs. {{amount_no_decimals_with_comma_separator}} PYG" }, PEN: { money_format: "S/. {{amount}}", money_with_currency_format: "S/. {{amount}} PEN" }, PHP: { money_format: "&#8369;{{amount}}", money_with_currency_format: "&#8369;{{amount}} PHP" }, PLN: { money_format: "{{amount_with_comma_separator}} zl", money_with_currency_format: "{{amount_with_comma_separator}} zl PLN" }, QAR: { money_format: "QAR {{amount_with_comma_separator}}", money_with_currency_format: "QAR {{amount_with_comma_separator}}" }, RON: { money_format: "{{amount_with_comma_separator}} lei", money_with_currency_format: "{{amount_with_comma_separator}} lei RON" }, RUB: { money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}", money_with_currency_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB" }, RWF: { money_format: "{{amount_no_decimals}} RF", money_with_currency_format: "{{amount_no_decimals}} RWF" }, WST: { money_format: "WS$ {{amount}}", money_with_currency_format: "WS$ {{amount}} WST" }, SAR: { money_format: "{{amount}} SR", money_with_currency_format: "{{amount}} SAR" }, STD: { money_format: "Db {{amount}}", money_with_currency_format: "Db {{amount}} STD" }, RSD: { money_format: "{{amount}} RSD", money_with_currency_format: "{{amount}} RSD" }, SCR: { money_format: "Rs {{amount}}", money_with_currency_format: "Rs {{amount}} SCR" }, SGD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} SGD" }, SYP: { money_format: "S&pound;{{amount}}", money_with_currency_format: "S&pound;{{amount}} SYP" }, ZAR: { money_format: "R {{amount}}", money_with_currency_format: "R {{amount}} ZAR" }, KRW: { money_format: "&#8361;{{amount_no_decimals}}", money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW" }, LKR: { money_format: "Rs {{amount}}", money_with_currency_format: "Rs {{amount}} LKR" }, SEK: { money_format: "{{amount_no_decimals}} kr", money_with_currency_format: "{{amount_no_decimals}} kr SEK" }, CHF: { money_format: "SFr. {{amount}}", money_with_currency_format: "SFr. {{amount}} CHF" }, TWD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} TWD" }, THB: { money_format: "{{amount}} &#xe3f;", money_with_currency_format: "{{amount}} &#xe3f; THB" }, TZS: { money_format: "{{amount}} TZS", money_with_currency_format: "{{amount}} TZS" }, TTD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} TTD" }, TND: { money_format: "{{amount}}", money_with_currency_format: "{{amount}} DT" }, TRY: { money_format: "{{amount}}TL", money_with_currency_format: "{{amount}}TL" }, UGX: { money_format: "Ush {{amount_no_decimals}}", money_with_currency_format: "Ush {{amount_no_decimals}} UGX" }, UAH: { money_format: "â‚´{{amount}}", money_with_currency_format: "â‚´{{amount}} UAH" }, AED: { money_format: "Dhs. {{amount}}", money_with_currency_format: "Dhs. {{amount}} AED" }, UYU: { money_format: "${{amount_with_comma_separator}}", money_with_currency_format: "${{amount_with_comma_separator}} UYU" }, VUV: { money_format: "${{amount}}", money_with_currency_format: "${{amount}}VT" }, VEF: { money_format: "Bs. {{amount_with_comma_separator}}", money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF" }, VND: { money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;", money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} VND" }, XBT: { money_format: "{{amount_no_decimals}} BTC", money_with_currency_format: "{{amount_no_decimals}} BTC" }, XOF: { money_format: "CFA{{amount}}", money_with_currency_format: "CFA{{amount}} XOF" }, ZMW: { money_format: "K{{amount_no_decimals_with_comma_separator}}", money_with_currency_format: "ZMW{{amount_no_decimals_with_comma_separator}}" }}
        this.currentCurrency = bstore.get('currentCurrency')
        this.format = _settings.currencyFormat || "money_with_currency_format"
        this.events = events

        if(this.currentCurrency && Shopify.currency.active !== this.currentCurrency){
            this.convertAll({})
        }
        this.events.on('booster:content:update', (params = {})=>this.convertAll(params))
        this.events.on('booster:price:update', this.priceUpdate.bind(this))
    }

    formatMoney(o, m) {
        "string" == typeof o && (o = o.replace(".", ""));
        var t = "",
            n = /\{\{\s*(\w+)\s*\}\}/,
            a = m || "${{amount}}";
    
        function _(o, m) {
            return void 0 === o ? m : o
        }

        function r(o, m, t, n) {
            if (m = _(m, 2), t = _(t, ","), n = _(n, "."), isNaN(o) || null == o) return 0;
            var a = (o = (o / 100).toFixed(m)).split(".");
            return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + t) + (a[1] ? n + a[1] : "")
        }
        switch (a.match(n)[1]) {
            case "amount":
                t = r(o, 2);
                break;
            case "amount_no_decimals":
                t = r(o, 0);
                break;
            case "amount_with_comma_separator":
                t = r(o, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                t = r(o, 0, ".", ",")
        }
        return a.replace(n, t)
    }

    priceUpdate({elements}){
        let oldCurrency = Shopify.currency.active
        let newCurrency = bstore.get("currentCurrency")
        let newFormat = this.getFormat(newCurrency)
        let oldFormat = this.getFormat(oldCurrency)
        if(oldCurrency == newCurrency) return
        for(let element of elements){
            this.elemConvert({element, oldCurrency, newCurrency, oldFormat, newFormat})
        }
    }

    elemConvert({element, oldCurrency = false, newCurrency = false, newFormat = false, oldFormat = false}){
        let amount = element.innerText
        if(!amount || amount.trim() == '') return
        let oldc = oldCurrency || Shopify.currency.active
        if(!oldc) return
        let newc = newCurrency || bstore.get("currentCurrency")
        if(!newc) return
        let newf = newFormat || this.getFormat(newc)
        let oldf = oldFormat || this.getFormat(oldc)
        let u;

        u = -1 !== oldf.indexOf("amount_no_decimals") ? Currency.convert(100 * parseInt(amount.replace(/[^0-9]/g, ""), 10), oldc, newc) : "JOD" === oldc || "KWD" == oldc || "BHD" == oldc ? Currency.convert(parseInt(amount.replace(/[^0-9]/g, ""), 10) / 10, oldc, newc) : Currency.convert(parseInt(amount.replace(/[^0-9]/g, ""), 10), oldc, newc)

        element.innerHTML = this.formatMoney(u, newf)
        element.dataset.currency = newc
    }

    convert({amount = false, oldc = false, newc = false}){
        if(!amount) return amount
        oldc = oldc || Shopify.currency.active
        if(!oldc) return amount
        newc = newc || bstore.get("currentCurrency")
        if(!newc) return amount
        let newf = this.getFormat(newc)
        let oldf = this.getFormat(oldc)
        let u
        u = -1 !== oldf.indexOf("amount_no_decimals") ? Currency.convert(100 * parseInt(amount.replace(/[^0-9]/g, ""), 10), oldc, newc) : "JOD" === oldc || "KWD" == oldc || "BHD" == oldc ? Currency.convert(parseInt(amount.replace(/[^0-9]/g, ""), 10) / 10, oldc, newc) : Currency.convert(parseInt(amount.replace(/[^0-9]/g, ""), 10), oldc, newc)

        return this.formatMoney(u, newf)
    }

    convertAll({oldCurrency = false, newCurrency = false, selector = '.jsPrice', format = this.format}) {
        let oldc = oldCurrency || Shopify.currency.active
        if(!oldc) return
        let newc = newCurrency || bstore.get("currentCurrency")
        if(!newc) return
        if(newc == oldc) return
        let oldf = this.moneyFormats[oldc][format] || '{{amount}}'
        let newf = this.moneyFormats[newc][format] || '{{amount}}'

        let conts = document.querySelectorAll(selector)
        for(let i = 0, maxi = conts.length; i < maxi; ++i){
            let u;
            let elem = conts[i]
            if(elem.dataset.currency == newc) continue
            let amount = elem.innerText
            if(!amount || amount.trim() == '') continue

            u = -1 !== oldf.indexOf("amount_no_decimals") ? Currency.convert(100 * parseInt(amount.replace(/[^0-9]/g, ""), 10), oldc, newc) : "JOD" === oldc || "KWD" == oldc || "BHD" == oldc ? Currency.convert(parseInt(amount.replace(/[^0-9]/g, ""), 10) / 10, oldc, newc) : Currency.convert(parseInt(amount.replace(/[^0-9]/g, ""), 10), oldc, newc)

            elem.innerHTML = this.formatMoney(u, newf)
            elem.dataset.currency = newc
        }

        bstore.set('currentCurrency', newc)
        this.currentCurrency = newc
    }

    getFormat(currency = false, format = false){
        format = format || _settings.currencyFormat || "money_with_currency_format"
        currency = currency || Shopify.currency.active
        return this.moneyFormats[currency][format]
    }
}

class BstrFreeShipping{
    constructor({events, cfx}){
        this.events = events
        this.cfx = cfx
        this.goal = parseFloat(_settings.freeShippingAmount.trim()) * 100
        this.current = 0
        this.format = this.cfx.getFormat(Shopify.currency.active)
        this.events.on('booster:cart:update', this.updateBars.bind(this))
        this.events.on('booster:content:update', this.updateBars.bind(this))
    }

    updateBars(params = {}){
        if (params.lastUpdate && params.data) {
            setTimeout(() => {
                let total_raw = params.data.total_raw || 0;
                this.current = total_raw;

                let percentage = Math.min(total_raw / this.goal * 100, 100)
                let left = this.cfx.convert({amount: this.cfx.formatMoney(this.goal - total_raw, this.format)})

                let head = document.querySelectorAll('[data-free-shipping-head]')
                let bars = document.querySelectorAll('[data-free-shipping-bar]')
                let cart = document.querySelectorAll('[data-free-shipping-cart]')

                for(let h of head){
                    if (percentage == 100) {
                        var fsText = h.dataset.gotFreeShipping
                            fsText = fsText.replace('free shipping', '<a href="/policies/shipping-policy">free shipping</a>');
                    }
                    else {
                        var fsText = h.dataset.freeShippingText.replace("We're checking for free shipping", `Add <span class="jsPrice">${left}</span> more for free shipping`)
                            fsText = fsText.replace('free shipping', '<a href="/policies/shipping-policy">free shipping</a>');
                    }                    
                    h.innerHTML = '<strong>' + fsText + '</strong>'
                    h.style.color = '#2E7880'
                }
                for(let b of bars){
                    b.style.width = percentage + '%'
                }
                for(let c of cart){
                    if (percentage == 100) {
                        var fsText = c.dataset.gotFreeShipping
                            fsText = fsText.replace('free shipping', '<a href="/policies/shipping-policy">free shipping</a>');
                    }
                    else {
                        var fsText = c.dataset.freeShippingText.replace("We're checking for free shipping", `Add <span class="jsPrice">${left}</span> more for free shipping`)
                            fsText = fsText.replace('free shipping', '<a href="/policies/shipping-policy">free shipping</a>');
                    }                    
                    c.innerHTML = fsText
                }

            }, 350)
        }
    }
}

class BstrWishList{
    constructor({events}){
        this.events = events
        this.init()
    }

    remove(ele){

        /* Capture wishlist from local storage */
        let wishlistDataStorage = JSON.parse(localStorage.getItem('wishlist')) || [];

        /* Add or remove the current product from the wishlist */
        let wishlistButton = ele;
        if (wishlistButton) {
        /* for(let data of wishlistButton) { */
    
            let wishData = {
              productId: wishlistButton.dataset.productId
            };

            wishlistDataStorage = wishlistDataStorage.filter(item => item.productId !== wishData.productId);
            localStorage.setItem('wishlist', JSON.stringify(wishlistDataStorage));

            window.parent.pageWistlist();
            this.init();
  
        /* } */
        }

    }
  
    toggle(ele){

      /* Capture wishlist from local storage */
      let wishlistDataStorage = JSON.parse(localStorage.getItem('wishlist')) || [];

      /* Add or remove the current product from the wishlist */
      let wishlistButton = ele;
      if (wishlistButton) {
      /* for(let data of wishlistButton) { */
  
          let wishData = {
            productId: wishlistButton.dataset.productId,
            productUrl: wishlistButton.dataset.productUrl,
            productImagemain: wishlistButton.dataset.productImagemain,
            productImagezoom: wishlistButton.dataset.productImagezoom,
            productSoldout: wishlistButton.dataset.productSoldout,
            productOnsale: wishlistButton.dataset.productOnsale,
            productNewitem: wishlistButton.dataset.productNewitem,
            productBestseller: wishlistButton.dataset.productBestseller,
            productLimitededition: wishlistButton.dataset.productLimitededition,
            productCloseoutitem: wishlistButton.dataset.productCloseoutitem,
            productRegular: wishlistButton.dataset.productRegular,
            productSpecial: wishlistButton.dataset.productSpecial,
            productPalette: wishlistButton.dataset.productPalette,
            productStars: wishlistButton.dataset.productStars,             
            productTitle: wishlistButton.dataset.productTitle,
            productPricefrom: wishlistButton.dataset.productPricefrom,
            productPriceamnt: wishlistButton.dataset.productPriceamnt,
            productPriceeach: wishlistButton.dataset.productPriceeach
          };

          let isAlreadyInWishlist = wishlistDataStorage.some(item => item.productId === wishData.productId);
          if (isAlreadyInWishlist) {
            wishlistDataStorage = wishlistDataStorage.filter(item => item.productId !== wishData.productId);
            localStorage.setItem('wishlist', JSON.stringify(wishlistDataStorage));
            if (wishlistButton.innerHTML.trim() != '') {
                wishlistButton.innerHTML = 
               `<svg viewBox="0 0 24 24" role="graphics-symbol img" fill="none" xmlns="http://www.w3.org/2000/svg"><title>Heart Icon</title><path d="M8.96173 18.9109L9.42605 18.3219L8.96173 18.9109ZM12 5.50063L11.4596 6.02073C11.601 6.16763 11.7961 6.25063 12 6.25063C12.2039 6.25063 12.399 6.16763 12.5404 6.02073L12 5.50063ZM15.0383 18.9109L15.5026 19.4999L15.0383 18.9109ZM9.42605 18.3219C7.91039 17.1271 6.25307 15.9603 4.93829 14.4798C3.64922 13.0282 2.75 11.3345 2.75 9.1371H1.25C1.25 11.8026 2.3605 13.8361 3.81672 15.4758C5.24723 17.0866 7.07077 18.3752 8.49742 19.4999L9.42605 18.3219ZM2.75 9.1371C2.75 6.98623 3.96537 5.18252 5.62436 4.42419C7.23607 3.68748 9.40166 3.88258 11.4596 6.02073L12.5404 4.98053C10.0985 2.44352 7.26409 2.02539 5.00076 3.05996C2.78471 4.07292 1.25 6.42503 1.25 9.1371H2.75ZM8.49742 19.4999C9.00965 19.9037 9.55954 20.3343 10.1168 20.6599C10.6739 20.9854 11.3096 21.25 12 21.25V19.75C11.6904 19.75 11.3261 19.6293 10.8736 19.3648C10.4213 19.1005 9.95208 18.7366 9.42605 18.3219L8.49742 19.4999ZM15.5026 19.4999C16.9292 18.3752 18.7528 17.0866 20.1833 15.4758C21.6395 13.8361 22.75 11.8026 22.75 9.1371H21.25C21.25 11.3345 20.3508 13.0282 19.0617 14.4798C17.7469 15.9603 16.0896 17.1271 14.574 18.3219L15.5026 19.4999ZM22.75 9.1371C22.75 6.42503 21.2153 4.07292 18.9992 3.05996C16.7359 2.02539 13.9015 2.44352 11.4596 4.98053L12.5404 6.02073C14.5983 3.88258 16.7639 3.68748 18.3756 4.42419C20.0346 5.18252 21.25 6.98623 21.25 9.1371H22.75ZM14.574 18.3219C14.0479 18.7366 13.5787 19.1005 13.1264 19.3648C12.6739 19.6293 12.3096 19.75 12 19.75V21.25C12.6904 21.25 13.3261 20.9854 13.8832 20.6599C14.4405 20.3343 14.9903 19.9037 15.5026 19.4999L14.574 18.3219Z" fill="#666666"/></svg><h2 class="wishlist_text">Add to your wishlist</h2>`;
            }
          }
          else {
            wishlistDataStorage.push(wishData);
            localStorage.setItem('wishlist', JSON.stringify(wishlistDataStorage));
            if (wishlistButton.innerHTML.trim() != '') {
                wishlistButton.innerHTML = 
               `<svg viewBox="0 0 24 24" role="graphics-symbol img" fill="none" xmlns="http://www.w3.org/2000/svg"><title>Heart Icon</title><path d="M2 9.1371C2 14 6.01943 16.5914 8.96173 18.9109C10 19.7294 11 20.5 12 20.5C13 20.5 14 19.7294 15.0383 18.9109C17.9806 16.5914 22 14 22 9.1371C22 4.27416 16.4998 0.825464 12 5.50063C7.50016 0.825464 2 4.27416 2 9.1371Z" fill="currentColor"/></svg><h2 class="wishlist_text">Saved in your wishlist</h2>`;
            }
          }
  
      /* } */
      }

      let wishlistDataLength = wishlistDataStorage.length;
      if (wishlistDataLength == 0) {
        let wishlistDesktop = document.querySelector(`span.wishlist__count--desktop`);
            wishlistDesktop.style.display = 'none';
            wishlistDesktop.innerText = wishlistDataLength;
        let wishlistMobile = document.querySelector(`span.wishlist__count--mobile`);
            wishlistMobile.style.display = 'none';
            wishlistMobile.innerText = wishlistDataLength;
      }
      else {
        let wishlistDesktop = document.querySelector(`span.wishlist__count--desktop`);
            wishlistDesktop.style.display = 'flex';
            wishlistDesktop.innerText = wishlistDataLength;
        let wishlistMobile = document.querySelector(`span.wishlist__count--mobile`);
            wishlistMobile.style.display = 'flex';
            wishlistMobile.innerText = wishlistDataLength;
      }

    }

    async init(){

      /* Capture wishlist from local storage */
      let wishlistDataStorage = JSON.parse(localStorage.getItem('wishlist')) || [];

      /* Set the initial button text based on whether the product is in the wishlist or not */
      let wishlistButton = document.querySelectorAll('.wishlist_button');
      if (wishlistButton) {
        for(let i = 0; i < wishlistButton.length; i++) {
    
          let wishData = {
            productId: wishlistButton[i].dataset.productId
          };
  
          let isAlreadyInWishlist = wishlistDataStorage.some(item => item.productId === wishData.productId);
          if (isAlreadyInWishlist) {
          /*if (wishlistButton[i].innerHTML.trim() == '') {*/
                wishlistButton[i].innerHTML = 
               `<svg viewBox="0 0 24 24" role="graphics-symbol img" fill="none" xmlns="http://www.w3.org/2000/svg"><title>Heart Icon</title><path d="M2 9.1371C2 14 6.01943 16.5914 8.96173 18.9109C10 19.7294 11 20.5 12 20.5C13 20.5 14 19.7294 15.0383 18.9109C17.9806 16.5914 22 14 22 9.1371C22 4.27416 16.4998 0.825464 12 5.50063C7.50016 0.825464 2 4.27416 2 9.1371Z" fill="currentColor"/></svg><h2 class="wishlist_text">Saved in your wishlist</h2>`;
          /*}*/
          }
          else {
          /*if (wishlistButton[i].innerHTML.trim() == '') {*/
                wishlistButton[i].innerHTML = 
               `<svg viewBox="0 0 24 24" role="graphics-symbol img" fill="none" xmlns="http://www.w3.org/2000/svg"><title>Heart Icon</title><path d="M8.96173 18.9109L9.42605 18.3219L8.96173 18.9109ZM12 5.50063L11.4596 6.02073C11.601 6.16763 11.7961 6.25063 12 6.25063C12.2039 6.25063 12.399 6.16763 12.5404 6.02073L12 5.50063ZM15.0383 18.9109L15.5026 19.4999L15.0383 18.9109ZM9.42605 18.3219C7.91039 17.1271 6.25307 15.9603 4.93829 14.4798C3.64922 13.0282 2.75 11.3345 2.75 9.1371H1.25C1.25 11.8026 2.3605 13.8361 3.81672 15.4758C5.24723 17.0866 7.07077 18.3752 8.49742 19.4999L9.42605 18.3219ZM2.75 9.1371C2.75 6.98623 3.96537 5.18252 5.62436 4.42419C7.23607 3.68748 9.40166 3.88258 11.4596 6.02073L12.5404 4.98053C10.0985 2.44352 7.26409 2.02539 5.00076 3.05996C2.78471 4.07292 1.25 6.42503 1.25 9.1371H2.75ZM8.49742 19.4999C9.00965 19.9037 9.55954 20.3343 10.1168 20.6599C10.6739 20.9854 11.3096 21.25 12 21.25V19.75C11.6904 19.75 11.3261 19.6293 10.8736 19.3648C10.4213 19.1005 9.95208 18.7366 9.42605 18.3219L8.49742 19.4999ZM15.5026 19.4999C16.9292 18.3752 18.7528 17.0866 20.1833 15.4758C21.6395 13.8361 22.75 11.8026 22.75 9.1371H21.25C21.25 11.3345 20.3508 13.0282 19.0617 14.4798C17.7469 15.9603 16.0896 17.1271 14.574 18.3219L15.5026 19.4999ZM22.75 9.1371C22.75 6.42503 21.2153 4.07292 18.9992 3.05996C16.7359 2.02539 13.9015 2.44352 11.4596 4.98053L12.5404 6.02073C14.5983 3.88258 16.7639 3.68748 18.3756 4.42419C20.0346 5.18252 21.25 6.98623 21.25 9.1371H22.75ZM14.574 18.3219C14.0479 18.7366 13.5787 19.1005 13.1264 19.3648C12.6739 19.6293 12.3096 19.75 12 19.75V21.25C12.6904 21.25 13.3261 20.9854 13.8832 20.6599C14.4405 20.3343 14.9903 19.9037 15.5026 19.4999L14.574 18.3219Z" fill="#666666"/></svg><h2 class="wishlist_text">Add to your wishlist</h2>`;
          /*}*/
          }
  
        }
      }

      let wishlistDataLength = wishlistDataStorage.length;
      if (wishlistDataLength == 0) {
        let wishlistDesktop = document.querySelector(`span.wishlist__count--desktop`);
            wishlistDesktop.style.display = 'none';
            wishlistDesktop.innerText = wishlistDataLength;
        let wishlistMobile = document.querySelector(`span.wishlist__count--mobile`);
            wishlistMobile.style.display = 'none';
            wishlistMobile.innerText = wishlistDataLength;
      }
      else {
        let wishlistDesktop = document.querySelector(`span.wishlist__count--desktop`);
            wishlistDesktop.style.display = 'flex';
            wishlistDesktop.innerText = wishlistDataLength;
        let wishlistMobile = document.querySelector(`span.wishlist__count--mobile`);
            wishlistMobile.style.display = 'flex';
            wishlistMobile.innerText = wishlistDataLength;
      }

    }
}

class BstrLocalize{
    constructor({events, cfx}){
        this.events = events
        this.cfx = cfx
        if(_settings.geolocation){
            this.events.on('booster:geo:visitor', this.localize.bind(this))
        }
    }

    async localize(params){
        if(bstore.get('bstrLocalized')) return
        bstore.set('bstrLocalized', true, 1440)

        let currency = params.currency.code
        let language = params.language.code
        let return_to = window.location.pathname
        let redirect = false

        if(language != Shopify.locale && Object.keys(bstri18n.locales).includes(language)){
            let lang = bstri18n.locales[language];
            let current = bstri18n.locales[Shopify.locale];
            if(!current.primary){
                return_to = return_to.replace(`${current.url}`, '');
            }
            if(!lang.primary){
                return_to = `${lang.url}${return_to}`;
            }
            redirect = true;
        }

        let mode = bstri18n.currency_mode;
        let currencies = bstri18n.currencies;
  
        if(mode != 'none' && currencies.includes(currency)){
            if(mode == 'convert' && bstore.get('currentCurrency') != currency){
                this.cfx.convertAll({oldCurrency: bstore.get('currentCurrency') || Shopify.currency.active, newCurrency: currency});
                this.events.trigger('booster:currency:changed')
            } else if(Shopify.currency.active != currency) {
                let form = new FormData();
                form.append('form_type', 'currency');
                form.append('currency', currency);
                await fetch(`${window.Shopify.routes.root}cart/update`, {body: form, method: 'POST'});
                if(!redirect){
                    return window.location.reload();
                }
            }
        }

        if(redirect) return window.location = return_to
    }
}

class BstrCntr{
    constructor(id = '[data-bstr-cntr]'){
        this.id = id
        this.counters = []
        this.interval = false
        this.initCounters()
    }

    initCounters(){
        let cts = document.querySelectorAll(`${this.id}:not([data-bstr-initd])`)
        if(!cts.length){
            return
        }
        let interval = parseInt(cts[0].dataset.bstrCntrInterval) * 1000
        if(this.interval){
            clearInterval(this.interval)
        }
        for(let ct of cts){
            this.counters.push(ct)
            ct.dataset.bstrInitd = "true"
        }
        this.interval = setInterval(this.countManagement.bind(this), interval)
    }

    countManagement(){
        let cache = {};
        for (let i = 0, maxi = this.counters.length; i < maxi; ++i) {
            let item = this.counters[i];
            if (cache[item.dataset.bstrCntrId]) {
              item.innerText = cache[item.dataset.bstrCntrId];
              continue;
            }

            let limitFull = item.dataset.bstrCntrLimit;
            let limitHalf = item.dataset.bstrCntrLimit * 0.5;
            let limitRand = Math.floor(Math.random() * (limitFull - limitHalf) + limitHalf);
            let limitCurr = parseInt(item.innerText) || limitRand;

            let countCurr = getRandomInt(Math.max(limitCurr - limitCurr * 0.1, 1), Math.min(limitCurr + limitCurr * 0.1, limitFull));
                countCurr = (countCurr < limitHalf) ? limitHalf : countCurr

            item.innerText = countCurr;
            cache[item.dataset.bstrCntrId] = countCurr;
        }
    }
}

class BstrCopycat{
    constructor(){
        document.addEventListener('contextmenu', function(e) {
            return e.preventDefault();
        });
        this.preventInspectElement();
        
        if(_settings.copycatText){
            this.preventTextSelect();
        }
    }

    preventTextSelect(){
        let style = document.createElement('style');
        style.innerText = `*:not(textarea):not(input):not(select):not(form):not(datalist):not(fieldset):not(option) {-webkit-touch-callout: none !important;-webkit-user-select: none !important;-khtml-user-select: none !important;-moz-user-select: none !important;-ms-user-select: none !important;user-select: none !important;}`
        document.body.appendChild(style);
    }

    preventInspectElement(){
        document.onkeydown = function(e) {
            if (e.defaultPrevented) {
                return;
            }

            if(e.code == "F12" || e.key == "F12"){
                return false;
            }

            if(e.ctrlKey && e.shiftKey && (e.key == "j" || e.key == "J" || e.code == "KeyJ")) {
                return false;
            }

            if(e.ctrlKey && e.shiftKey && (e.key == "c" || e.key == "C" || e.code == "KeyC")) {
                return false;
            }

            if(e.ctrlKey && e.shiftKey && (e.key == "i" || e.key == "I" || e.code == "KeyI")) {
                return false;
            }

            if(e.ctrlKey && (e.key == "u" || e.key == "U" || e.code == "KeyU")) {
                return false;
            }

            if(_settings.copycatText){
                if(e.ctrlKey && (e.key == "c" || e.key == "C" || e.code == "KeyC")) {
                return false;
                }
        
                if(e.ctrlKey && (e.key == "a" || e.key == "A" || e.code == "KeyA")) {
                return false;
                }
        
                if(e.ctrlKey && (e.key == "x" || e.key == "X" || e.code == "KeyX")) {
                return false;
                }
            }
        }
    }
}

class BstrCountdown {
    constructor({events}){
        this.events = events
        this.init()
        this.events.on('booster:content:update', ()=>this.init())
    }


    async init(container = document){
        let bstrCts = container.querySelectorAll('[data-countdown]')
        if(!this.bstrCts){
            this.bstrCts = [...bstrCts];
        } else {
            this.bstrCts.push(...bstrCts);
        }

        let ctSettings = bstore.get('bstrCts');
        if(!ctSettings){
            ctSettings = {}
        }
        let time = new Date().getTime();
        let randomize = parseInt(_settings.countdownRandom);

        function enumMultiplier(format){
            switch (format) {
                case 'days':
                    return 86400000;
                case 'hours':
                    return 3600000;
                case 'minutes':
                    return 60000;
                case 'seconds':
                    return 1000;
                default:
                    return 86400000;
            }
        }

        let expiry, minExp, maxExp;
        if(_settings.countdownTime.includes('/')) {
            expiry = new Date(_settings.countdownTime).setHours(0,0,0,0);
            minExp = expiry;
            maxExp = expiry;
        }
        else {
            let expiry = parseInt(_settings.countdownTime);
            let multiply = enumMultiplier(_settings.countdownTimeFormat);
            minExp = time + Math.abs(expiry - randomize) * multiply;
            maxExp = time + Math.abs(expiry + randomize) * multiply;
        }

        function getExpiry(timer, type, set = true){
            if (type == 'app'){
                let newTime = getRandomInt(minExp, maxExp);
                timer.dataset.expiryTime = newTime;
                return newTime;
            } else {
                let expiry;
                let duration = timer.dataset.duration;
                if(duration.includes('/')){
                    expiry = new Date(duration).setHours(0,0,0,0);
                } else {
                    expiry = time + parseInt(duration) * enumMultiplier(timer.dataset.durationFormat);
                }
                if(!set){
                    return expiry;
                }
                timer.dataset.expiryTime = expiry;
                return expiry;
            }
        }

        for(let i = 0, maxi = bstrCts.length; i < maxi; ++i){
            let timer = bstrCts[i];
            timer.removeAttribute('data-countdown');
            let key = timer.dataset.ctKey;
            let ctType = timer.dataset.duration && timer.dataset.durationFormat ? 'block' : 'app';
            
            if(!ctSettings[key] || ctSettings[key] < time || Shopify.designMode){
                let expires = getExpiry(timer, ctType);
                ctSettings[key] = expires;
            } else {
                if(ctType == 'app'){
                    if(ctSettings[key] > maxExp){
                        let newTime = getRandomInt(minExp, maxExp);
                        ctSettings[key] = newTime;
                        timer.dataset.expiryTime = newTime;
                    } else {
                        timer.dataset.expiryTime = ctSettings[key];
                    }
                } else {
                    let expires = getExpiry(timer, ctType, false);
                    if(ctSettings[key] > expires){
                        timer.dataset.expiryTime = expiry;
                        ctSettings[key] = expires;
                    } else {
                        timer.dataset.expiryTime = ctSettings[key];
                    }
                }
            }
        }

        bstore.set('bstrCts', ctSettings, 1440);
        if(!this.countdownStarted){
            setInterval(this.tickCountdowns.bind(this), 1000);
            this.countdownStarted = true;
        }        
    }


    tickCountdowns(){
        for(let i = 0, maxi = this.bstrCts.length; i < maxi; ++i){
            this.tickCountdown(this.bstrCts[i]);
        }
    }

    tickCountdown(ct){
        if(ct.dataset.countdownTimedOut == "true"){
            return;
        }

        let delta = (parseInt(ct.dataset.expiryTime) - Date.now()) / 1000;

        let daysEl = ct.querySelector('.days');
        let hoursEl = ct.querySelector('.hours');
        let minutesEl = ct.querySelector('.minutes');
        let secondsEl = ct.querySelector('.seconds');

        if(delta <= 0){
            if(ct.dataset.ctKey == "cart-ct-timer"){
                ct.dataset.expiryTime = Date.now() + 300000
                return
            }
            ct.dataset.countdownTimedOut = "true";
            if(daysEl) daysEl.innerText = "00";
            if(hoursEl) hoursEl.innerText = "00";
            if(minutesEl) minutesEl.innerText = "00";
            if(secondsEl) secondsEl.innerText = "00";
            return;
        }

        let days = Math.floor(delta / 86400);
        if(daysEl) daysEl.innerText = days >= 10 && days || "0"+days;
        delta -= days * 86400;

        let hours = Math.floor(delta / 3600) % 24;
        delta -= hours * 3600;
        if(hoursEl) hoursEl.innerText = hours >= 10 && hours || "0"+hours;

        let minutes = Math.floor(delta / 60) % 60;
        delta -= minutes * 60;
        if(minutesEl) minutesEl.innerText = minutes >= 10 && minutes || "0"+minutes;

        let seconds = delta % 60;
        if(secondsEl) secondsEl.innerText = seconds >= 10 && Math.floor(seconds) || "0"+Math.floor(seconds); 
    }
}

class BstrDynTitle{
    constructor(){
        this.originalTitle = document.title
        let intr = parseInt(_settings.dynTitleIntr)
        this.intr = isNaN(intr) ? 2500 : intr * 1000
        this.initLeavePage()
        this.initOnPage()
    }

    initLeavePage(){
        let titles = _settings.BPDynTitle.trim().split('\n')
        this.LPTitles = [this.originalTitle, ...titles]
        window.addEventListener('blur', ()=>{
            clearInterval(this.OPRotation)
            this.OPRotation = false
            document.title = this.originalTitle
            if(titles[0] == "") return
            if(this.LPRotation) return
            this.LPRotation = setInterval(()=>this.rotateTitles(this.LPTitles), this.intr)
        })
    }

    initOnPage(){
        let titles = _settings.OPDynTitle.trim().split('\n')
        this.OPTitles = [this.originalTitle, ...titles]
        window.addEventListener('focus', ()=>{
            clearInterval(this.LPRotation)
            this.LPRotation = false
            document.title = this.originalTitle
            if(titles[0] == "") return
            if(this.OPRotation) return
            this.OPRotation = setInterval(()=>this.rotateTitles(this.OPTitles), this.intr)
        })
        if(!this.LPRotation && titles[0] != ""){
            this.OPRotation = setInterval(()=>this.rotateTitles(this.OPTitles), this.intr)
        }
    }

    rotateTitles(titles){
        let len = titles.length
        let ct = titles.indexOf(document.title)
        ++ct
        if(ct >= len) ct = 0
        document.title = titles[ct]
    }
}

class BstrElements{
    constructor({events, basync, cfx, cart}){
        this.events = events
        this.cfx = cfx
        this.cart = cart
        this.basync = basync
        this.stock = new BstrStock({events})
        this.wishlist = new BstrWishList({events})
        this.searchTimer = null;
        this.marqueeIntervals = {}
        this.cardTemplate = document.getElementById('productCardTemplate')
        this.checkPagination()
        this.sliderObserve()
        this.initMarquees()
        this.initElements()
        this.initUnsubscribe()
        this.events.on('booster:content:update', this.initElements.bind(this))
        this.events.on('booster:currency:changed', ()=>this.cfxInput())
        this.rendering = false;
    }

    initElements(){
        this.quantityHandlers()
        this.cfxInput()
        this.initSearch()
        this.mobileMenus()
        this.boosterRevert()
        this.localizeDates()
    }

    async initMarquees(){
        let marquees = document.querySelectorAll('[data-blocktype="barTextMarquee"]');
        for(let i = 0, maxi = marquees.length; i < maxi; i++){
          let element = marquees[i];
          let id = element.dataset.blockid;
          var self = this;
          this.marqueeIntervals[id] = setInterval(self.scrollMarquee, 3000, element);
        }
    }
 
    scrollMarquee(container){
        if(container.dataset.currentmessage >= container.dataset.messagescount){
            container.dataset.currentmessage = 0;
            container.style.transform = "translateY(0%)";
            return;
        }
        container.dataset.currentmessage++;
        container.style.transform = `translateY(-${container.dataset.currentmessage * 100}%)`;
    }

    checkPagination(){
        if(_settings.pagination == 'infinite'){

            let pList = document.querySelector('.collection-pagination--product-list');
            if(!pList){
                return;
            }
            /*
            setting self to "this" wreaks havoc inside of theme.js
            self = this;
            */
            window.addEventListener('scroll', debounce( ()=>{
                if((window.innerHeight + window.scrollY) >= pList.offsetHeight && this.rendering === false){
                    let next = document.querySelector('.pagination--hidden');
                    if(!next){
                        return;
                    }
                    this.rendering = true;
                    this.renderChangePage(false, next, false);
                }
            }, 150));
        }
    }

    sliderObserve(){
        document.querySelectorAll('.slider__holder').forEach((i) => {
            if (i) {
                const observer = new window.IntersectionObserver(([entry]) => {
                    if (entry.isIntersecting) {
                        entry.target.querySelectorAll('img.slide__staticBlack').forEach(el => {
                            el.classList.remove('slide__staticBlack')
                            el.classList.add('slide__staticImage')
                        });
                        return;
                    }
                }, {
                    root: null,
                    threshold: 0.1 /* set offset 0.1 means trigger if at least 10% of element in viewport */
                })
                observer.observe(i);
            }
        })
    }

    boosterRevert(){
        let reverts = document.querySelectorAll('.booster--revert div:not(.booster--revert)');
        for(let r = 0, maxr = reverts.length; r < maxr; ++r){
          reverts[r].classList.add('booster--revert');
        }
    }

    initSearch(){
        let searchFields = document.querySelectorAll('input[data-search]:not([data-bstr-initd])');
        for(let i = 0, maxi = searchFields.length; i < maxi; ++i){
            searchFields[i].dataset.bstrInitd = "true"
            searchFields[i].oninput = debounce(this.searchSuggest.bind(this), 230, false);
        }
    }

    mobileMenus(){
        if (($('#open-mobile-nav_A').prop('checked')) || ($('#open-mobile-nav_B').prop('checked')) || ($('#open-mobile-nav_C').prop('checked')) || ($('#filterToggle_A').prop('checked')) || ($('#filterToggle_B').prop('checked'))) {
            $('body').css({'overflow': 'hidden'});
        }
        else {
            $('body').css({'overflow': 'visible'});
        }

        $('#open-mobile-nav_A').on('change', function() { 
            if (this.checked) {
                $('body').css({'overflow': 'hidden'});
            }
            else {
                $('body').css({'overflow': 'visible'});
            }
        });

        $('#open-mobile-nav_B').on('change', function() { 
            if (this.checked) {
                $('body').css({'overflow': 'hidden'});
            }
            else {
                $('body').css({'overflow': 'visible'});
            }
        });

        $('#open-mobile-nav_C').on('change', function() { 
            if (this.checked) {
                $('body').css({'overflow': 'hidden'});
            }
            else {
                $('body').css({'overflow': 'visible'});
            }
        });

        $('#filterToggle_A').on('change', function() { 
            if (this.checked) {
                $('body').css({'overflow': 'hidden'});
            }
            else {
                $('body').css({'overflow': 'visible'});
            }
        });

        $('#filterToggle_B').on('change', function() { 
            if (this.checked) {
                $('body').css({'overflow': 'hidden'});
            }
            else {
                $('body').css({'overflow': 'visible'});
            }
        });
    }

    cfxInput(){
        if(bstri18n.currency_mode == "convert"){
            let c = bstore.get('currentCurrency')
            if(!c) return
            if(c == Shopify.currency.active) return
            document.querySelectorAll('[data-currency-selector]').forEach((e)=>{
                e.value = c
            })
        }
    }

    quantityHandlers(){
        let inputs = document.querySelectorAll('[data-qty-int-input]:not([data-bstr-initd])')
        for(let inp of inputs){
            inp.dataset.bstrInitd = "true"
            inp.oninput = debounce((e)=>{inp.onchange(e)}, 500, false)
        }
    }

    convertCurrencyChange(select){
        let currency = select.value
        if(currency == bstore.get('currentCurrency')) return
        this.cfx.convertAll({oldCurrency: bstore.get('currentCurrency') || Shopify.currency.active, newCurrency: currency})
    }

    submitCurrencyChange(select){
        return select.closest('form').submit()
    }

    languageChange(select){
        return window.location = select.value
    }

    stickyBuy(button, e){
        if(button.dataset.productId){
            let container = button.closestEl('.sticky--mobile')
            if(container.classList.contains('sticky--closed')){
                return container.classList.remove('sticky--closed')
            }
        } else {
            let id = button.dataset.buyButton
            let form = document.getElementById('product_form_' + id)
            if(form) this.cart.addToCart(e, form)
        }
    }

    stickyBuyScrollUp(){
        let sticky = document.querySelector('.sticky--mobile');
            sticky.classList.add('hide')
            sticky.classList.add('scrolling')

        let topbar = document.querySelector('.top-info-bar').clientHeight;
        let header = document.querySelector('.page__header--mobile').clientHeight;
        let botbar = document.querySelector('.bottom-info-bar').clientHeight;

        let toppart = document.querySelector('.container__top-part');
            toppart.style.height = topbar + header + botbar + 'px'

        document.querySelector('.product__atc').scrollIntoView({behavior: 'smooth', block: 'end'});
    }

    closeSticky(button){
        button.closest('.sticky--mobile').classList.add('sticky--closed')
    }

    async renderSort(select){
        let url = new URL(document.URL);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page')
        let stateURL = url.href;

        let container = document.querySelector('.collection-pagination--product-list');
        container.style.opacity = '0.5';
    
        let {html} = await this.basync.load({url, section: 'product-list', selector: '#shopify-section-product-list'})
        if(!html) return container.style.opacity = '1'
        container.innerHTML = html;
    
        history.replaceState({}, '', stateURL);
        this.events.trigger('booster:content:update', {trigger: 'sort'})
        container.style.opacity = '1';
    }

    submitSearch(target){
        let form = target.closestEl('form');
        form.submit();
    }

    openSearch(target){
      /*
        if(!target){
            target = document.querySelector('.search__container--abs');
            target.classList.add('focused');
            target = target.querySelector('input');
        } else {
            target.closestEl('[data-search-container]').classList.add('focused');
            if(target.tagName != "input"){
            target = target.closestEl('input');
            }
        }
        target.focus();

        const searchContainer = document.querySelector('[data-search-container].focused');
        searchContainer.closestEl('input').focus();

        let container = target.closestEl('[data-search-suggest]');
        if(!target.value.length){
            boosterTheme.handleEmptySearch(container);
        }
      */
    }

    openSearchProducts(){
      var productsD = document.querySelector('.search-results__products-div');
      var productsS = document.querySelector('.search-results__products-span');
      var productsL = document.querySelector('.search-results__products-list');
          productsD.style.borderBottom = '2px solid ' + getComputedStyle(document.documentElement).getPropertyValue('--accentColor');
          productsD.style.cursor = 'default';
          productsS.style.color = getComputedStyle(document.documentElement).getPropertyValue('--accentColor');

      var collectionsD = document.querySelector('.search-results__collections-div');
      var collectionsS = document.querySelector('.search-results__collections-span');
      var collectionsL = document.querySelector('.search-results__collections-list');
          collectionsD.style.borderBottom = '2px solid #dddddd';
          collectionsD.style.cursor = 'pointer';
          collectionsS.style.color = '#777777';

      var pagesD = document.querySelector('.search-results__pages-div');
      var pagesS = document.querySelector('.search-results__pages-span');
      var pagesL = document.querySelector('.search-results__pages-list');
          pagesD.style.borderBottom = '2px solid #dddddd';
          pagesD.style.cursor = 'pointer';
          pagesS.style.color = '#777777';

          productsL.style.display = 'flex';
          collectionsL.style.display = 'none';
          pagesL.style.display = 'none';
    }

    openSearchCollections(){
      var productsD = document.querySelector('.search-results__products-div');
      var productsS = document.querySelector('.search-results__products-span');
      var productsL = document.querySelector('.search-results__products-list');
          productsD.style.borderBottom = '2px solid #dddddd';
          productsD.style.cursor = 'pointer';
          productsS.style.color = '#777777';

      var collectionsD = document.querySelector('.search-results__collections-div');
      var collectionsS = document.querySelector('.search-results__collections-span');
      var collectionsL = document.querySelector('.search-results__collections-list');
          collectionsD.style.borderBottom = '2px solid ' + getComputedStyle(document.documentElement).getPropertyValue('--accentColor');
          collectionsD.style.cursor = 'default';
          collectionsS.style.color = getComputedStyle(document.documentElement).getPropertyValue('--accentColor');

      var pagesD = document.querySelector('.search-results__pages-div');
      var pagesS = document.querySelector('.search-results__pages-span');
      var pagesL = document.querySelector('.search-results__pages-list');
          pagesD.style.borderBottom = '2px solid #dddddd';
          pagesD.style.cursor = 'pointer';
          pagesS.style.color = '#777777';

          productsL.style.display = 'none';
          collectionsL.style.display = 'flex';
          pagesL.style.display = 'none';
    }

    openSearchPages(){
      var productsD = document.querySelector('.search-results__products-div');
      var productsS = document.querySelector('.search-results__products-span');
      var productsL = document.querySelector('.search-results__products-list');
          productsD.style.borderBottom = '2px solid #dddddd';
          productsD.style.cursor = 'pointer';
          productsS.style.color = '#777777';

      var collectionsD = document.querySelector('.search-results__collections-div');
      var collectionsS = document.querySelector('.search-results__collections-span');
      var collectionsL = document.querySelector('.search-results__collections-list');
          collectionsD.style.borderBottom = '2px solid #dddddd';
          collectionsD.style.cursor = 'pointer';
          collectionsS.style.color = '#777777';

      var pagesD = document.querySelector('.search-results__pages-div');
      var pagesS = document.querySelector('.search-results__pages-span');
      var pagesL = document.querySelector('.search-results__pages-list');
          pagesD.style.borderBottom = '2px solid ' + getComputedStyle(document.documentElement).getPropertyValue('--accentColor');
          pagesD.style.cursor = 'default';
          pagesS.style.color = getComputedStyle(document.documentElement).getPropertyValue('--accentColor');

          productsL.style.display = 'none';
          collectionsL.style.display = 'none';
          pagesL.style.display = 'flex';
    }
    
    closeSearch(target){
      /*
        target.closestEl('[data-search-container]').classList.remove('focused');
      */
    }

    renderProductCard(product){

      let price = product.price;
      let price_min = product.price_min;
      let price_max = product.price_max;
      let price_varies = (price_min != price_max) ? true : false;
      let price_on_sale = ((product.compare_at_price_min == 0) && (product.compare_at_price_max == 0)) ? false : true;
      let price_per_bar_min = (price_min < _settings.soapBundlePerBarMin) ? price_min : _settings.soapBundlePerBarMin;
      let review_stars = '4.6';
      let tags = product.tags;
      let card = this.cardTemplate.cloneNode(true).content.children[0];
      let image = product.featured_image.url;
      let type = product.type;
      let url = new URL(window.location.origin)
      const $c = (q)=>card.querySelector(q)
console.log(product)
      /*  product image */
      if (image) {
        $c('.card__img--container').href = product.url;
        $c('[data-product-image-featured]').src = image;
        if (product.vendor == 'Gildan') {
          $c('[data-product-image-secondary]').src = image.split('full')[0] + 'half' + image.split('full')[1];
          $c('[data-product-image-secondary]').classList.add('card__img--secondary');
        }
        else {
          $c('[data-product-image-secondary]').style.display = 'none';
          $c('.card__palette').style.display = 'none';
          for(var i = 0, maxi = tags.length; i < maxi; ++i){
            if (tags[i].startsWith('colorpalette')) {
              $c('.card__palette').style.display = 'block';
              break;
            }
          }
        }
      }
      else {
        $c('.card__img--container').href = product.url;
        $c('[data-product-image-featured]').src = url + 'cdn/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_520x.gif';
        $c('[data-product-image-secondary]').style.display = 'none';
      }

        $c('.tag--sale').style.display = 'none';
        $c('.tag--custom_NEW-ITEM').style.display = 'none';
        $c('.tag--custom_BEST-SELLER').style.display = 'none';
        $c('.tag--custom_LIMITED-EDITION').style.display = 'none';
        $c('.tag--custom_CLOSEOUT-ITEM').style.display = 'none';

      if (price_on_sale) {
        $c('.tag--sale').style.display = 'inline';
      }
      else {
        for(var i = 0, maxi = tags.length; i < maxi; ++i){
          if (tags[i].includes('NEW-ITEM')) $c('.tag--custom_NEW-ITEM').style.display = 'inline';
          if (tags[i].includes('BEST-SELLER')) $c('.tag--custom_BEST-SELLER').style.display = 'inline';
          if (tags[i].includes('LIMITED-EDITION')) $c('.tag--custom_LIMITED-EDITION').style.display = 'inline';
          if (tags[i].includes('CLOSEOUT-ITEM')) $c('.tag--custom_CLOSEOUT-ITEM').style.display = 'inline';
        }
      }

      /*  product review stars */
      if (type == 'Gift Cards') {
        $c('.product__review-stars').style.display = 'none';
      }
      else {
        for(var i = 0, maxi = tags.length; i < maxi; ++i){
          if (tags[i].startsWith('reviewstars')) {
            review_stars = tags[i].substr(tags[i].length - 3);
            break;
          }
        }
        $c('.review-stars-num').innerHTML = '(' + review_stars + ')';
      }

      /*  product title  */
      $c('.card__title').href = product.url;
      $c('.card__title').innerText = product.title;

      /*  product countdown  */
      /*  let countdown = $c('[data-countdown]');
          countdown.classList.add('hide');
          countdown.removeAttribute('data-countdown');
      */

      if (product.available) {
        $c('.tag--soldout').style.display = 'none';

        if (product.vendor == 'Adams Handmade Soap') {
          if (price_on_sale) {
            if (price_varies) {
              $c('.card__product-price').innerHTML = '<span class="card__price" style="font-size: 16px; font-weight: normal; color: #666666;">from <span class="jsPrice" style="font-size: 16px; color: #892208;"><strong>$' + price_per_bar_min + '</strong></span>/bar</span>';
            }
            else {
              $c('.card__product-price').innerHTML = '<span class="card__price" style="font-size: 16px; font-weight: normal; color: #666666;"><span class="jsPrice" style="font-size: 16px; color: #892208;"><strong>$' + price_per_bar_min + '</strong></span> ea.</span>';
            }
          }
          else {
            if (price_varies) {
              $c('.card__product-price').innerHTML = '<span class="card__price" style="font-size: 16px; font-weight: normal; color: #666666;">from <span class="jsPrice card__price--sale" style="font-size: 16px;"><strong>$' + price_per_bar_min + '</strong></span>/bar</span>';
            }
            else {
              $c('.card__product-price').innerHTML = '<span class="card__price" style="font-size: 16px; font-weight: normal; color: #666666;"><span class="jsPrice card__price--sale" style="font-size: 16px;"><strong>$' + price_per_bar_min + '</strong></span> ea.</span>';
            }
          }
        }
        else {
          if (price_varies) {
            if (price_on_sale) {
              $c('.card__product-price').innerHTML = '<span class="card__price" style="font-size: 16px; font-weight: normal; color: #666666;">from <span class="jsPrice" style="font-size: 16px; color: #892208;"><strong>$' + price_min + '</strong></span></span>';
            }
            else {
              $c('.card__product-price').innerHTML = '<span class="card__price" style="font-size: 16px; font-weight: normal; color: #666666;">from <span class="jsPrice card__price--sale" style="font-size: 16px;"><strong>$' + price_min + '</strong></span></span>';
            }
          }
          else {
            if (price_on_sale) {
              $c('.card__product-price').innerHTML = '<span class="card__price" style="font-size: 16px; font-weight: normal; color: #666666;"><span class="jsPrice" style="font-size: 16px; color: #892208;"><strong>$' + price + '</strong></span> ea.</span>';
            }
            else {
              $c('.card__product-price').innerHTML = '<span class="card__price" style="font-size: 16px; font-weight: normal; color: #666666;"><span class="jsPrice card__price--sale" style="font-size: 16px;"><strong>$' + price + '</strong></span> ea.</span>';
            }
          }
        }
      }
      else {
        $c('[data-product-image-featured]').style.filter = 'grayscale(100%)';
        $c('[data-product-image-secondary]').style.filter = 'grayscale(100%)';

        if (price_varies) {
          $c('.card__product-price').innerHTML = '<span class="card__price" style="font-size: 16px; font-weight: normal; color: #666666;">from <span class="jsPrice card__price--soldout" style="font-size: 16px;"><strong>$' + price_min + '</strong></span></span>';
        }
        else {
          $c('.card__product-price').innerHTML = '<span class="card__price" style="font-size: 16px; font-weight: normal; color: #666666;"><span class="jsPrice card__price--soldout" style="font-size: 16px;"><strong>$' + price_min + '</strong> ea.</span></span>';
        }        
      }
 
      card.classList.add('col-md-1-5');
      return card;
    }

    createSearchSuggestResult(product){
        return this.renderProductCard(product);
    }

    populateSearchSuggest(container, data){

      container.style.display = 'flex';

      var productsD = document.querySelector('.search-results__products-div');
      var productsS = document.querySelector('.search-results__products-span');
      var productsL = document.querySelector('.search-results__products-list');

      var collectionsD = document.querySelector('.search-results__collections-div');
      var collectionsS = document.querySelector('.search-results__collections-span');
      var collectionsL = document.querySelector('.search-results__collections-list');

      var pagesD = document.querySelector('.search-results__pages-div');
      var pagesS = document.querySelector('.search-results__pages-span');
      var pagesL = document.querySelector('.search-results__pages-list');

      if ((productsL.style.display == 'none') && (collectionsL.style.display == 'none') && (pagesL.style.display == 'none')) {
          productsD.style.borderBottom = '2px solid ' + getComputedStyle(document.documentElement).getPropertyValue('--accentColor');
          productsD.style.cursor = 'default';
          productsS.style.color = getComputedStyle(document.documentElement).getPropertyValue('--accentColor');
          productsL.style.display = 'flex';

          collectionsD.style.borderBottom = '2px solid #dddddd';
          collectionsD.style.cursor = 'pointer';
          collectionsS.style.color = '#777777';
          collectionsL.style.display = 'none';

          pagesD.style.borderBottom = '2px solid #dddddd';
          pagesD.style.cursor = 'pointer';
          pagesS.style.color = '#777777';
          pagesL.style.display = 'none';
      }

          productsL.innerHTML = '';
          collectionsL.innerHTML = '';
          pagesL.innerHTML = '';


      var products = data.resources.results.products;
      if(products.length > 0){
        var pageProducts = document.createElement('div');
            pageProducts.style.marginTop = '25px';
            pageProducts.classList.add('card--holder-container');
            pageProducts.classList.add('row');
            pageProducts.classList.add('col-12');

/*      var frag = document.createDocumentFragment();      */
        for(var i = 0, maxi = products.length; i < maxi; ++i){
          pageProducts.appendChild(this.createSearchSuggestResult(products[i]));
        }

        productsL.style.padding = '0px 0px';
        productsL.appendChild(pageProducts);
      }
      else {
        var pageProducts = document.createElement('div');
            pageProducts.style.marginTop = '25px';

          const element = document.createElement('a');
                element.innerText = 'No products found.';
                element.style.cursor = 'default';
                element.style.lineHeight = '2.0';
                element.style.textDecorationLine = 'none';
                element.classList.add('col-12');
                element.classList.add('search-container__search-links');

            pageProducts.appendChild(element);

        productsL.style.padding = '0px 20px';
        productsL.appendChild(pageProducts);
      }

/*
      var articles = data.resources.results.articles;
      if(articles.length > 0){
        var articleContainer = document.createElement('div');
        var articleTitle = document.createElement('h4');

        articleTitle.innerText = "Articles";
        articleTitle.style.marginTop = "0px"
        articleTitle.classList.add("col-12");

        articleContainer.append(articleTitle)

        var articleFrag = document.createDocumentFragment();
        for(var a = 0, a_maxi = articles.length; a < a_maxi; ++a){
            const element = document.createElement('a');
            element.href = articles[a].url
            element.innerText = articles[a].title
            element.classList.add("col-12");
            articleContainer.appendChild(element);
        }

        container.appendChild(articleContainer);
      }
*/
      
      var collections = data.resources.results.collections;
      if(collections.length > 0){
        var pageContainer = document.createElement('div');
            pageContainer.style.marginTop = '25px';

        for(var p = 0, p_maxi = collections.length; p < p_maxi; ++p){
          if (collections[p].title.startsWith('Home -')) continue;
          const element = document.createElement('a');
                element.href = collections[p].url
                element.innerText = collections[p].title
                element.style.lineHeight = '2.0';
                element.style.textDecorationLine = 'none';
                element.classList.add('col-12');
                element.classList.add('search-container__search-links');

            pageContainer.appendChild(element);
        }

        collectionsL.appendChild(pageContainer);
      }
      else {
        var pageContainer = document.createElement('div');
            pageContainer.style.marginTop = '25px';

          const element = document.createElement('a');
                element.innerText = 'No collections found.';
                element.style.cursor = 'default';
                element.style.lineHeight = '2.0';
                element.style.textDecorationLine = 'none';
                element.classList.add('col-12');
                element.classList.add('search-container__search-links');
          
            pageContainer.appendChild(element);

        collectionsL.appendChild(pageContainer);
      }
       
      var pages = data.resources.results.pages;
      if(pages.length > 0){
        var pageContainer = document.createElement('div');
            pageContainer.style.marginTop = '25px';

        for(var p = 0, p_maxi = pages.length; p < p_maxi; ++p){
          const element = document.createElement('a');
                element.href = pages[p].url
                element.innerText = pages[p].title
                element.style.lineHeight = '2.0';
                element.style.textDecorationLine = 'none';
                element.classList.add('col-12');
                element.classList.add('search-container__search-links');

            pageContainer.appendChild(element);
        }

        pagesL.appendChild(pageContainer);
      }
      else {
        var pageContainer = document.createElement('div');
            pageContainer.style.marginTop = '25px';

        const element = document.createElement('a');
              element.innerText = 'No pages found.';
              element.style.cursor = 'default';
              element.style.lineHeight = '2.0';
              element.style.textDecorationLine = 'none';
              element.classList.add('col-12');
              element.classList.add('search-container__search-links');

            pageContainer.appendChild(element);

        pagesL.appendChild(pageContainer);
      }

      return this.events.trigger('booster:content:update');

    }

    resetSuggest(event){
      let productsL = document.querySelector('.search-results__products-list');
      let collectionsL = document.querySelector('.search-results__collections-list');
      let pagesL = document.querySelector('.search-results__pages-list');
          productsL.innerHTML = '';
          collectionsL.innerHTML = '';
          pagesL.innerHTML = '';

          productsL.style.display = 'none';
          collectionsL.style.display = 'none';
          pagesL.style.display = 'none';

      let parent = event.closest('[data-search-container]');
      let container = parent.querySelector('[data-search-suggest]');
          event.style.display = 'none';
          document.getElementById('data-search-container-form').reset();
          return this.handleEmptySearch(container);
    }
  
    searchSuggest(event){
        var self = this;
        let query = event.target.value;
        let parent = event.target.closest('[data-search-container]');
        let container = parent.querySelector('[data-search-suggest]');
        let reset = document.getElementById('data-search-container-reset');
        if(query.length > 0){
            reset.style.display = 'block';
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(function () {
                let q = `${window.Shopify.routes.root}search/suggest.json?q=${query}&resources[type]=product,page,article,collection`;            
                fetch(q)
                .then(r=>r.json())
                .then(data=>self.populateSearchSuggest(container, data));
            }, 500);
        } else {
            reset.style.display = 'none';
            return this.handleEmptySearch(container);
        }
    }

    handleEmptySearch(container){

      container.style.display = 'none';
    /*container.innerHTML = '';*/

      return this.events.trigger('booster:content:update');

    }

    async quickBuy(e){
        if(window.innerWidth < 768) return
        e.preventDefault();
        const button = '<button class="close" onclick="closeModal(event)"><i class="uil uil-arrow-left"></i>' + _bstrLocale.buttons.back_to_shop + '</button>'
        const $e = (e, q)=>e.querySelector(q)
        let url = new URL(e.target.closest('a').href);
        let {parser} = await this.basync.load({url, section: 'product-page__product'})
        if($e(parser, '.product__row').classList.contains('product__row--marketplace')){
            let container = $e(parser, '.product__row');
            container.classList.remove('product__row--marketplace');
            let middle = $e(container, '.product__page--info');
            let title = $e(middle, '.product__title');
            let price = $e(middle, '.product__price--holder');
            container.removeChild(middle);
            let sticky = $e(container, '.product__page--info')
            if(!$e(sticky, '.product__title')) sticky.insertBefore(title, sticky.firstChild);
            if(!$e(sticky, '.product__price')) $e(sticky, '.product__title').insertAdjacentElement('afterend', price);
        }
        let quickBuy = document.getElementById('quickbuy__modal');
        $e(quickBuy, '.content').innerHTML = button + $e(parser, 'body').innerHTML;
        quickBuy.style.display = 'flex';
        this.events.trigger('booster:content:update', {trigger: 'quickbuy'})
    }

    toggleTab(self, id){
        let tab = self;
        let container = tab.closest('.tab__container');
        container.querySelector('.tab--show').classList.remove('tab--show');
        container.querySelector(`#${id}`).classList.add('tab--show');
        let tabs = container.querySelector('.tab__holder');
        tabs.querySelector('.tab--active').classList.remove('tab--active');
        self.classList.add('tab--active');
    }
  
    toggleCollectionView(view, target){
        if(target.classList.contains('view--active')){
          return;
        }
        target.closestEl('.view--active').classList.remove('view--active');
        target.classList.add('view--active');
        let rows = document.querySelectorAll('.row--product');
        if(view == 'card'){
          for(var i = 0, maxi = rows.length; i < maxi; ++i){
            rows[i].classList.remove('card--expanded');
          }
        } else {
          for(var i = 0, maxi = rows.length; i < maxi; ++i){
            rows[i].classList.add('card--expanded');
          }
        }
    }

    async renderChangePage(e = false, clickTarget, overwrite = false){

        if(e) e.preventDefault()
        let container = document.querySelector('.collection-pagination--product-list')
        container.style.opacity = '0.5'
        clickTarget.disabled = true
        
        let url = new URL(clickTarget.href)
        let {html} = await this.basync.load({url, selector: '.collection-pagination--product-list'})
        if(!html){
            container.style.opacity = '1'
            return clickTarget.disabled = false
        }
    
        if(overwrite){
            container.innerHTML = html
            this.wishlist.init();
            $('.my-rating').starRating({ starSize: 20 });
            container.scrollIntoView({block: "start", behavior: "smooth"})
        } else {
            clickTarget.closest('.pagination').remove();
        /*  This "innerHTML" line was changed to jQuery "append" because the tab
            focus would disappear and restart at the very top of the page.  */
        /*  container.innerHTML += html  */
            $('.collection-pagination--product-list').append(html);
            this.wishlist.init();
            $('.my-rating').starRating({ starSize: 20 });
        }

        this.rendering = false;
        /*
        turned off for automatically loaded pagination
        let stateURL = new URL(document.URL);
        stateURL.searchParams.set('page', url.searchParams.get('page'));
        history.pushState({}, '', stateURL);
        */
        container.style.opacity = '1';

        return this.events.trigger('booster:content:update', {trigger: 'pagination'})

    }

    localizeDates(){
        let dates = document.querySelectorAll('[data-bstr-delivery-date]:not([data-bstr-initd])')
        for(let date of dates){
            date.dataset.bstrInitd = "true"
            let n = parseInt(date.innerText.replace(/[^\d]/g, ''))
            if(isNaN(n)) continue
            let cdate = new Date()
            cdate.setDate(cdate.getDate() + n)
            const options = { weekday: 'short', year: 'numeric', month: 'short', day: '2-digit' };
            date.innerText = cdate.toLocaleDateString(`${Shopify.locale}`, options)
        }
    }

    initUnsubscribe(){
        $('.shopify-email-marketing-confirmation__container h1').html('BYE BYE BUDDY');
        $('.shopify-email-marketing-confirmation__container h1').css('display', 'block');
    }
}

class BstrFilters{
    constructor({events, basync}){
        this.wishlist = new BstrWishList({events})
        this.basync = basync
        this.events = events
        this.initListeners()
        this.clearFilters(false)
        this.events.on('booster:content:update', ()=>this.initListeners())
    }

    initListeners(){
        for(let e of document.querySelectorAll('input[data-filter-href]:not([data-bstr-initd])')) {
            e.dataset.bstrInitd = "true"
            e.addEventListener('change', this.modifyFilters.bind(this))
        }

        for(let e of document.querySelectorAll('[data-filter-href]:not([data-bstr-initd]):not(input)')) {
            e.dataset.bstrInitd = "true"
            e.addEventListener('click', this.modifyFilters.bind(this))
        }
    }

    clearFilters(event){
      if (event) {
        window.location.href = window.location.origin + window.location.pathname;
      }
      else {
        if ($('.collection-pagination--banner-wrapper').length > 0) {
          let clear = false;
          let url = new URL(window.location.href);
          for (const [key, value] of url.searchParams) {
              if (key.includes('filter')) {
                  clear = true;
                  break;
              }
          }
          if (clear) {
              for(let e of document.querySelectorAll('.filter__mobile--clear')) {
                  e.style.display = 'block';
              }
              document.getElementById('gFillFilter').style.fill = getComputedStyle(document.documentElement).getPropertyValue('--accentColor')
              document.getElementById('gFillFilter').style.stroke = getComputedStyle(document.documentElement).getPropertyValue('--accentColor')
          }
          else {
              for(let e of document.querySelectorAll('.filter__mobile--clear')) {
                  e.style.display = 'none';
              }
              document.getElementById('gFillFilter').style.fill = 'none'
              document.getElementById('gFillFilter').style.stroke = '#000000'
          }
        }
      }
    }

    modifyFilters(event){
        this.renderChangePage(event.target.dataset.filterHref, event.target.dataset.filterColor)

        let selectedProductCount = 0;
        let currentFilterCount = 0
        let hasSelectedFilter = 0;

        /*
        document.querySelectorAll('[data-filter-href]').forEach(value => {
            const productCount = Number(value.nextElementSibling.querySelector('[data-filter-count]').innerHTML)

            if(value.checked) {
                hasSelectedFilter++;
                selectedProductCount += productCount;
            }

            currentFilterCount += productCount;
        });

        if(hasSelectedFilter) {
            document.querySelector('.filter__mobile--current').innerText = selectedProductCount;
        } else {
            document.querySelector('.filter__mobile--current').innerText = currentFilterCount;
        }
        */
    }

    setInputState(state){
        for(let e of document.querySelectorAll('[data-filter-href]')){ e.disabled = !state }
    }

    urlParamsGetAll(url) {
      var queryString = url ? url.split('?')[1] : window.location.search.slice(1);
      var obj = {};
      if (queryString) {
        queryString = queryString.split('#')[0];
        var arr = queryString.split('&');
        for (var i = 0; i < arr.length; i++) {
          var a = arr[i].split('=');
          var paramName = a[0];
          var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];
          if (paramName.match(/\[(\d+)?\]$/)) {
            var key = paramName.replace(/\[(\d+)?\]/, '');
            if (!obj[key]) obj[key] = [];
            if (paramName.match(/\[\d+\]$/)) {
              var index = /\[(\d+)\]/.exec(paramName)[1];
              obj[key][index] = paramValue;
            } else {
              obj[key].push(paramValue);
            }
          } else {
            if (!obj[paramName]) {
              obj[paramName] = paramValue;
            } else if (obj[paramName] && typeof obj[paramName] === 'string'){
              obj[paramName] = [obj[paramName]];
              obj[paramName].push(paramValue);
            } else {
              obj[paramName].push(paramValue);
            }
          }
        }
      }
    
      return obj;
    }

    urlParamsSet(url, param, val) {
      var href = new URL(url);
          href.searchParams.set(param, val);
      return href.toString();
    }
  
    removeParamFromURL(url, param) {
        const urlObj = new URLSearchParams(url);
        return urlObj.getAll(param);
    }

    async renderChangePage(href, color){

      let setParams = '';

      /* for items with COLOR filter ONLY */
      let getColors = document.querySelector('.filter__color--current');
      if (getColors) {
        let getParams = this.urlParamsGetAll(window.location.origin + href)['filter.v.option.color'];
  
        if (getParams !== undefined) {
          if (Array.isArray(getParams)) {
            var filterColor = getParams.slice(-1)[0];
            setParams = this.urlParamsSet(window.location.origin + href, 'filter.v.option.color', filterColor);
            setParams = setParams.replace('%2B', '+');
            if (color !== 'false') document.querySelector('.filter__color--current').innerText = color;
          }
          else {
            var filterColor = getParams;
            setParams = this.urlParamsSet(window.location.origin + href, 'filter.v.option.color', filterColor);
            setParams = setParams.replace('%2B', '+');
            if (color !== 'false') document.querySelector('.filter__color--current').innerText = color;
          }
        }
        else {
          setParams = window.location.origin + href;
          document.querySelector('.filter__color--current').innerText = '';
        }
      }
      else {
        setParams = window.location.origin + href;
      }

      let container = document.querySelector('.collection-pagination--product-list');
      container.style.opacity = '0.5'
      this.setInputState(false)

      let url = new URL(setParams)
      let {html, json} = await this.basync.load({url, section: 'product-list', selector: '.collection-pagination--product-list', json: 'noscript'})

      if(!html){
          this.setInputState(true)
          container.style.opacity = '1'
          return
      }

      container.innerHTML = html;
      $('.my-rating').starRating({ starSize: 20, disableAfterRate: true });
      this.wishlist.init();

      history.pushState({}, '', setParams);
      
      this.events.trigger('booster:content:update')
      container.style.opacity = '1';

      this.renderFilters(json)
      this.clearFilters(false);

      for(let c of document.querySelectorAll('.collection__total-items')){
          c.innerText = json.count
      }

      return;

    }

      renderFilters(json){
        this.setInputState(true)

        for(let [k, v] of Object.entries(json.filters)){
            for(let f of v){
                let t = document.querySelector(`[data-filter="${k}-${f.value}"]`)
            /*  let c = t.nextElementSibling.querySelector('[data-filter-count]')
                if(c) c.innerText = f.count  */
                t.disabled = !f.count
                t.checked = f.active
                t.dataset.filterHref = f.active ? f.urls.remove : f.urls.add
                if(f.count){
                    t.closest('div').classList.remove('filter--disabled')
                } else {
                    t.closest('div').classList.add('filter--disabled')
                }
            }
        }
      }
}

class BstrOptOut {
    constructor() {
        this.buttonWait()
    }

    waitForElm(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }
    
            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    observer.disconnect();
                    resolve(document.querySelector(selector));
                }
            });
    
            /* If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336 */
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }

    buttonWait() {
        this.waitForElm('button.shopify-pc__banner__btn-accept').then((elm) => {
            let optOutButton = document.querySelector('button.shopify-pc__banner__btn-accept');
                optOutButton.classList.remove('shopify-pc__banner__btn-accept');
                optOutButton.classList.add('button');
                optOutButton.classList.add('button--primary');
                optOutButton.classList.add('button--filled');
                optOutButton.classList.add('button--primary__filled');
                optOutButton.innerHTML = '<span style="white-space: nowrap;">Accept All</span>';
        });
        this.waitForElm('button.shopify-pc__banner__btn-decline').then((elm) => {
            let optOutButton = document.querySelector('button.shopify-pc__banner__btn-decline');
                optOutButton.classList.remove('shopify-pc__banner__btn-decline');
                optOutButton.classList.add('button');
                optOutButton.classList.add('button--primary');
                optOutButton.classList.add('button--filled');
                optOutButton.classList.add('button--primary__filled');
                optOutButton.innerHTML = '<span style="white-space: nowrap;">Decline All</span>';
        });
        this.waitForElm('#pc--opt-out-email_input').then((elm) => {
            let optOutInput = document.querySelector('#pc--opt-out-email_input');
                optOutInput.placeholder = "Enter your email address";
        });
        this.waitForElm(`[for="pc--opt-out-email_input"]`).then((elm) => {
            let optOutLabel = document.querySelector(`[for="pc--opt-out-email_input"]`);
                optOutLabel.innerHTML = 'Email Address<span style="color: #ff0000;">*</span>';
        });
        this.waitForElm('button.pc--opt-out-form-button').then((elm) => {
            let optOutButton = document.querySelector('button.pc--opt-out-form-button');
                optOutButton.classList.add('button');
                optOutButton.classList.add('button--primary');
                optOutButton.classList.add('button--filled');
                optOutButton.classList.add('button--primary__filled');
                optOutButton.innerHTML = '<span>Submit</span>';
        });
        this.waitForElm('svg.icon-success').then((elm) => {
            let optOutSuccess =  document.querySelector('svg.icon-success');
                optOutSuccess.style.maxWidth = '40px';
                optOutSuccess.style.marginRight = '8px';
        });
    } 

}

class BstrGDPR {
    constructor(id = 'bstr--notice'){
        this.container = document.getElementById(id);
        if(!this.container){
            return
        }
        this.closeButton = this.container.querySelector('[data-gdpr-accept]');
        if(this.closeButton) this.closeButton.addEventListener('click', this.close.bind(this));
        this.open(true)
    }

    open(check = false){
        if(!this.container){
            return console.info('[OPEN] GDPR container not found.')
        }

        if(check && bstore.get('bstr_gdpr')){
            return
        }

        return this.container.style.display = 'block'
    }

    close(){
        if(!this.container){
            return console.info('[CLOSE] GDPR container not found.')
        }

        bstore.set('bstr_gdpr', 'true', 43200);
        return this.container.style.display = 'none'
    }
}

class BstrEvents{
    constructor(){
        this.listeners = {}
        this.logs = {}
    }

    on(event, cb){
        if(typeof cb !== "function"){
            throw '[BOOSTER EVENTS] Callback must be a function. Event: ' + event
        }

        if(this.logs[event]) cb.call(cb, this.logs[event])

        if(typeof this.listeners[event] === "undefined"){
            this.listeners[event] = [cb]
        } else {
            this.listeners[event].push(cb)
        }
    }

    trigger(event, params = {}, log = false){
        let cbs = this.listeners[event]
        let dom_prevented = document.dispatchEvent(new CustomEvent(event, {detail: params, cancelable: event.includes(':b*'), bubbles: true}))
        let rs = [dom_prevented]
        if(cbs && cbs.length){
            let prevented = !dom_prevented;
            for(let cb of cbs){
                try{
                    let r = cb.call(cb, {...params, prevented})
                    if(typeof r != "undefined"){
                        rs.push(r)
                        if(prevented !== true) prevented = r === false
                    }
                }catch(err){
                    console.info(`[BOOSTER EVENTS] Error caught on ${event}.\n${err}`)
                    continue;
                }                
            }
        }
        if(log) this.logs[event] = params
        return {values: rs, prevent: rs.includes(false)}
    }
}

class BstrIU{
    constructor({cfx, events, swatches}){
        this.cfx = cfx
        this.swatches = swatches
        this.events = events
        this.events.on('booster:variant:select', this.syncInputs.bind(this))
    }

    syncInputs(params){
        if(!params.selectedVariant.available) return
        let pid = params.product.id
        let vid = params.selectedVariant.id
        document.querySelectorAll(`[data-upsell-id="${pid}"]`).forEach((e)=>{
            if(e.tagName != "SELECT") return
            if(e.value == vid) return
            e.value = vid
        })
        this.toggleVariantIU()
    }

    toggleVariantIU(elem = false){
        let total = document.getElementById('inline-upsell__total')
        if(!total) return
        let stotal = document.getElementById('inline-upsell__discount')

        if(elem && elem.tagName == "SELECT"){
            let id = elem.dataset.upsellId;
            let variant = elem.value
            this.swatches.setProductVariant(id, variant)
        }

        let selected = document.querySelectorAll('input.inline-upsell__toggle:checked');
        let price = 0;
        let compare = 0;
        let elements = []
        let format = this.cfx.getFormat(Shopify.currency.active);
        for(let i = 0, maxi = selected.length; i < maxi; ++i){
            let input = document.getElementById(selected[i].dataset.for);
            let pprice = input.tagName == 'INPUT' ? parseInt(input.dataset.price) : parseInt(input.options[input.selectedIndex].dataset.price)
            let sprice = input.tagName == 'INPUT' ? parseInt(input.dataset.comparePrice) : parseInt(input.options[input.selectedIndex].dataset.comparePrice)
            let card = input.closestEl('.card--default')
            let cpprice = card.querySelector('[data-iu-price]')
            let csprice = card.querySelector('[data-iu-price-sale]')
            cpprice.innerHTML = this.cfx.formatMoney(pprice, format)
            elements.push(cpprice)
            if(sprice > pprice){
                csprice.parentElement.classList.add('card__price--sale')
                csprice.innerHTML = this.cfx.formatMoney(sprice, format)
                elements.push(csprice)
            } else {
                csprice.parentElement.classList.remove('card__price--sale')
                csprice.innerHTML = ''
            }
            price += pprice
            compare += sprice
        }
        total.innerHTML = this.cfx.formatMoney(price, format);
        stotal.innerHTML = compare > price ? this.cfx.formatMoney(compare, format) : ''
        elements.push(total, stotal)
        this.events.trigger('booster:price:update', {currency: Shopify.currency.active, elements})
    }
}

class BstrLazy{
    constructor({events, cname = 'lazyload'}){
      this.events = events
      this.class = cname;
      this.images = true;
      if ("loading" in HTMLImageElement.prototype && _settings.nativeLazyLoad) this.images = false
      this.init();
    }
  
    init(){
      if(!this.images) this.convertNative()

      this.observer = new IntersectionObserver(function(entries, self) {
        for(let i = 0, maxi = entries.length; i < maxi; ++i){
          let entry = entries[i];
          if(entry.isIntersecting) {
            let t = entry.target;
            t.classList.remove('lazyload');
            t.classList.add('lazyloaded');
            switch(t.tagName){
              case "IMG":
                t.dataset.sizes ? t.sizes = t.dataset.sizes : null;
                t.dataset.src ? t.src = t.dataset.src : null;
                t.dataset.srcset ? t.srcset = t.dataset.srcset : null;
                break;
              case "DIV":
                if(t.dataset.bgset){
                  let width = window.innerWidth;
                  let bgset = t.dataset.bgset.split(',');
                  for(let i = 0, maxi = bgset.length; i < maxi; ++i){
                    let bg = bgset[i].split(' ')
                    let w = parseInt(bg[1]);
                    if(w >= width || i + 1 == bgset.length){
                      t.style.backgroundImage = `url(${bg})`;
                      break;
                    }
                  }
                  break;
                }
                t.src = t.dataset.src;
                break;
              case "VIDEO":
                let v = t.querySelector('source');
                v.src = v.dataset.src;
                break;
              default:
                t.src = t.dataset.src;
                break;
            }
            self.unobserve(entry.target);
          }
        }
      }, {threshold: 0.05});
      
      let lazyloads = this.images ? document.querySelectorAll('.lazyload') : document.querySelectorAll('.lazyload:not([loading="lazy"])');
      for(let i = 0, maxi = lazyloads.length; i < maxi; ++i){
        this.observer.observe(lazyloads[i]);
      }
      
      this.events.on('booster:content:update', ()=>this.update())
    }

    convertNative(){
      var images = document.querySelectorAll('img[loading="lazy"]:not([data-bstr-initd])');
      for(let i = 0, maxi = images.length; i < maxi; ++i){
        let t = images[i];
        if(t.dataset.sizes) t.sizes = t.dataset.sizes;
        if(t.dataset.src) t.src = t.dataset.src;
        if(t.dataset.srcset) t.srcset = t.dataset.srcset;
        t.dataset.bstrInitd = "true"
      }
    }
  
    update(){
      if(!this.images) this.convertNative()
      let lazyloads = this.images ? document.querySelectorAll('.lazyload') : document.querySelectorAll('.lazyload:not([loading="lazy"])');
      for(let i = 0, maxi = lazyloads.length; i < maxi; ++i){
        this.observer.observe(lazyloads[i]);
      }
    }
}

class BstrNotify{
    constructor({events}){
        this.events = events
        this.popupHolder = document.getElementById('booster__popup--holder')
        this.events.on('booster:notify', this.fn.bind(this))
    }

    fn(data){
        var self = this;
        var popup;
        if(data.url){
            popup = document.createElement('a')
            popup.href = data.url;
            popup.target = "_blank";
        } else {
            popup = document.createElement('div');
        }
        data.id ? popup.dataset.id = data.id : null;
        const removeThisFn = function(){
            if(this.dataset.id){
            let notifs = bstore.get('bstr_notifs') || {};
            let dismissed = notifs.dismissed || [];
            dismissed.push(this.dataset.id);
            notifs.dismissed = dismissed;
            bstore.set('bstr_notifs', notifs, 120);
            }
            this.parentElement.removeChild(this);
        };
        popup.setAttribute('class', 'booster__popup booster__popup--'+data.type);
        popup.innerText = typeof data.message == 'string' ? data.message : JSON.stringify(data.message);
        self.popupHolder.appendChild(popup);
        popup.onclick = removeThisFn;
        popup.classList.add('anim__fade-in');
        if(data.expires === false){
            return;
        }
        setTimeout(function(){
            try{
            self.popupHolder.removeChild(popup);
            } catch(err){}
        }, data.expires || 5000);
    }
}

class BstrRecentlyBought{
    constructor(){
      if(typeof recentlyBoughtConfig == 'undefined') return
      this.config = recentlyBoughtConfig
      this.container = document.getElementById('recently-bought--holder')
      this.init()
    }
  
    async init(){
      let data = await fetch(this.config.allProductsUrl + '?section_id=api__recently-bought');
      let raw = await data.text();
      let parser = document.createElement('div');
      parser.innerHTML = raw;
      let parsed = JSON.parse(parser.querySelector('.shopify-section').innerText);
      parsed.names = parsed.names.split(',');
      parsed.names = parsed.names.filter(name=>name.trim()!='');
      if(!parsed.names.length) parsed.names = 'Alissa Ashford, Carroll Calley, Augustina Angulo, Kenna Kuntz, Hailey Hinkle, Breann Beckham, Raquel Roles, Bernetta Beeks'.split(',')
      this.recentlyBoughtCollection = parsed;
  
      setInterval(()=>this.render(), (_settings.recentlyBoughtInterval + _settings.recentlyBoughtRemain) * 1000)
    }
  
    render(){
      const RBC = this.container;
      const $rb = (q)=>RBC.querySelector(q)
  
      let img = $rb('.recently-bought--img img');
      let person = $rb('.recently-bought--who');
      let time = $rb('.recently-bought--when');
      let title = $rb('.recently-bought--what');
      let price = $rb('.recently-bought--price');
  
      let names = this.recentlyBoughtCollection.names;
      let products = this.recentlyBoughtCollection.collection;
  
      let product = products[getRandomInt(0, products.length - 1)];
      let name;
      if(this.config.useNames){
        name = names[getRandomInt(0, names.length - 1)].trim();
        if(this.config.nameFormat == 'shorten'){
          let sname = name.split(' ');
          name = sname.length == 1 ? sname[0] : `${sname[0]} ${sname[1][0]}.`;
        } else if(this.config.nameFormat == 'initials'){
          name = name.split(' ').reduce((n, e)=>{n += `${e[0]}. `; return n}, '')
        }
      } else {
        name = _bstrLocale.recentlyBought.someone
      }
  
      img.src = product.image;
      title.innerText = product.title.slice(0, 24);
      price.querySelector('.current-price').innerText = product.priceFormat;
      price.querySelector('.old-price').innerText = product.sale ? product.discountPriceFormat : '';
      person.innerText = _bstrLocale.recentlyBought.purchased.replace('%name%', name);
      time.innerText = _bstrLocale.recentlyBought.ago.replace('%time%', getRandomInt(2, 50))
      RBC.href = product.url;
  
      const image_ratio = $rb('.recently-bought--img-ratio')
      if(!image_ratio.dataset.widthAdjusted){
        image_ratio.style.width = RBC.clientHeight + 'px';
        image_ratio.dataset.widthAdjusted = "true";
      }
      RBC.classList.add('anim__fade-in');
  
      setTimeout(()=>{
        RBC.classList.remove('anim__fade-in')
      }, _settings.recentlyBoughtRemain * 1000);
    }
}

class BstrSlider {
    constructor({
        events,
        selector,
        breakpoints
    } = {}) {
        this._selector = selector || '[data-bstr-slider]';
        this._idSelector = this._selector.replace(/(\[data-|\])/g, '').replace(/-(\w)/g, (s)=>s[1].toUpperCase())
        this._breakpoints = breakpoints || {
            sm: 768,
            md: 1024
        }
        this._sliders = {};
        this._currentIndex = 0;
        this._resize = false
        this.init();
        events.on('booster:content:update', ()=>this.init())
    }

    _isVisible(s_rect, c_rect, vertical) {
        let c_rect_top    = c_rect.top - c_rect.top % 1;
        let s_rect_top    = s_rect.top - s_rect.top % 1;
        let c_rect_right  = c_rect.right - c_rect.right % 1;
        let s_rect_right  = s_rect.right - s_rect.right % 1;
        let c_rect_bottom = c_rect.bottom - c_rect.bottom % 1;
        let s_rect_bottom = s_rect.bottom - s_rect.bottom % 1;
        let c_rect_left   = c_rect.left - c_rect.left % 1;
        let s_rect_left   = s_rect.left - s_rect.left % 1;

        if (vertical) {
            return c_rect_top - s_rect_top <= 1 && c_rect_bottom - s_rect_bottom >= -1;
        } else {
            return c_rect_left - s_rect_left <= 1 && c_rect_right - s_rect_right >= -1;
        }
    }

    async _parentMoveCallback(slider) {
        let previous = parseInt(slider.dataset.bstrSliderCurrent)
        const vertical = slider.dataset.bstrSliderOrientation.toLowerCase() == "vertical"
        if(!slider.querySelector('[data-bstr-slide]')) return
        let current = vertical ? Math.round(slider.scrollTop / slider.querySelector('[data-bstr-slide]').offsetHeight) : Math.round(slider.scrollLeft / slider.querySelector('[data-bstr-slide]').offsetWidth)
        slider.dataset.bstrSliderCurrent = current
        let direction = previous - current > 0 ? '+' : '-'

        let s_children = slider.querySelectorAll('[data-bstr-slide]');
        let parray = []
        let carray = []

        const s_rect = slider.closest('[data-bstr-slide-holder]').getBoundingClientRect();
        for (let i = 0; i < s_children.length; ++i) {
            let child = s_children[i];
            if (this._isVisible(s_rect, child.getBoundingClientRect(), vertical)) {
                child.dataset.bstrSlide = "active"
                carray.push({
                    index: i,
                    target: child
                })
            } else if (child.dataset.bstrSlide == "active") {
                child.dataset.bstrSlide = ""
                parray.push({
                    index: i,
                    target: child
                })
            }
        }

        this._moveCallback && this._moveCallback({
            direction,
            slider,
            current: carray,
            previous: parray
        })

    }

    init(selector = false) {
        let slideScroll = document.querySelector('.slider--product-holder')
        if (slideScroll) {
            slideScroll.classList.remove('slide-scroll')
            slideScroll.classList.add('slide-scroll')
        }
        let sliders = document.querySelectorAll(`${selector || this._selector}:not([data-bstr-initd])`);
        for (let sliderComponent of sliders) {
            let slider = sliderComponent.querySelector('[data-bstr-slide-holder]');
            let id;

            if (sliderComponent.dataset[this._idSelector]) {
                id = sliderComponent.dataset[this._idSelector]
            } else {
                id = ++this._currentIndex
                sliderComponent.dataset[this._idSelector] = id
            }

            sliderComponent.setAttribute('data-bstr-initd', 'true')
            slider.dataset.bstrSliderId = id;

            let viewports = slider.dataset.bstrSlideHolder.split('|')
            if (viewports.length == 3) {
                this._sliders[id] = {
                    lg: parseInt(viewports[0]),
                    md: parseInt(viewports[1]),
                    sm: parseInt(viewports[2])
                }
            } else {
                let parsed = parseInt(viewports[0])
                this._sliders[id] = isNaN(parsed) ? {
                    lg: 1,
                    md: 1,
                    sm: 1
                } : {
                    lg: parsed,
                    md: parsed,
                    sm: parsed
                }
            }

            let buttons = [...sliderComponent.querySelectorAll('[data-bstr-slider-button]'), ...document.querySelectorAll(`[data-bstr-slider-button][data-bstr-for-slider="${id}"]`)]
            for (let button of buttons) {
                button.addEventListener('click', (e) => {
                    e.preventDefault()
                    e.stopImmediatePropagation()
                    this._move({
                        slider,
                        direction: button.dataset.bstrSliderButton || '+'
                    })
                });
            }

            /* Checks if auto play is enabled */
            if(slider.dataset.bstrAutoplay == "true") {
                const slideSpeed = slider.dataset.bstrSlideSpeed;
                this._autoplayHandler({
                slider,
                slideSpeed
                })
            }

            this._parentMoveCallback(slider)
            slider.addEventListener('scroll', debounce(() => this._parentMoveCallback(slider), 100), {
                passive: true
            })
        }

        if (this._resize) return
        this._resizeHandler();
        window.addEventListener('resize', debounce(this._resizeHandler.bind(this), 250), {
            passive: true
        });
        this._resize = true
    }

    _autoplayHandler({slider, slideSpeed}) {
        setInterval(() => {
            this._move({
                slider,
                direction:'+'
            })
        }, slideSpeed);
    }

    _resizeHandler() {
        if (window.innerWidth < this._breakpoints.sm) {
            this.viewport = 'sm'
        } else if (window.innerWidth < this._breakpoints.md) {
            this.viewport = 'md'
        } else {
            this.viewport = 'lg'
        }

        this.rawViewport = window.innerWidth;
    }

    _moveTo({
        index = 0,
        slider
    }) {
        let current = parseInt(slider.dataset.bstrSliderCurrent);
        let vertical = slider.dataset.bstrSliderOrientation.toLowerCase() == "vertical";
        let s_children = slider.querySelectorAll('[data-bstr-slide]');
        if(!s_children.length) return
        current = Math.max(Math.min(index, s_children.length - 1), 0)

        vertical ? slider.scrollTo(0, s_children[current].offsetTop - slider.offsetTop) : slider.scrollTo(s_children[current].offsetLeft - slider.offsetLeft - parseInt(window.getComputedStyle(slider).paddingLeft), 0)
    }

    _moveThumbTo({
        index = 0,
    }) {
        const width = screen.width;
        const target = document.querySelector(`[data-bstr-slider-thumb='${index}']`);

        if(width > 767)
            target.parentNode.scrollTop = target.offsetTop;
        else
            target.parentNode.scrollLeft = target.offsetLeft;
    }

    _move({
        direction,
        slider
    }) {
        let moveBy = this._sliders[slider.dataset.bstrSliderId][this.viewport];
        let current = parseInt(slider.dataset.bstrSliderCurrent);
        let previous = current;
        let vertical = slider.dataset.bstrSliderOrientation.toLowerCase() == "vertical";
        let s_children = slider.querySelectorAll('[data-bstr-slide]');
        if(!s_children.length) return
        let offset = vertical ? Math.round(1 / (s_children[0].offsetHeight / slider.offsetHeight)) : Math.round(1 / (s_children[0].offsetWidth / (slider.offsetWidth - parseInt(window.getComputedStyle(slider).paddingLeft))));

        current = direction === "+" ? Math.min(current + moveBy, s_children.length - offset) : Math.max(current - moveBy, 0)

        /* check if loop works */
        if(slider.dataset.bstrSlideLoop){
            if(current === previous){
                if(direction === "-"){
                    current = s_children.length - offset
                }else{
                    current = 0
                }
            }
        }

        vertical ? slider.scrollTo(0, s_children[current].offsetTop - slider.offsetTop) : slider.scrollTo(s_children[current].offsetLeft - slider.offsetLeft - parseInt(window.getComputedStyle(slider).paddingLeft), 0)
    }
}

class ProductSlider extends BstrSlider {

    constructor(props) {
        super(props)
        this.initThumbs()
        props.events.on('booster:content:update', this.initThumbs)
    }

    initThumbs(){
        let thumbs = document.querySelectorAll('[data-bstr-slider-thumb]:not([data-bstr-initd])')
        for(let thumb of thumbs){
            let sid = thumb.dataset.bstrSliderFor;
            let slider = sid ? document.querySelector(`[data-bstr-ppslider="${sid}"] [data-bstr-slide-holder]`) : thumb.closest('[data-bstr-ppslider]')
            let index = parseInt(thumb.dataset.bstrSliderThumb)
            thumb.addEventListener('click', ()=>super._moveTo({slider, index}))
            if(thumb.getAttribute('data-bstr-slider-thumb-hover') != null) thumb.addEventListener('mouseover', ()=>super._moveTo({slider, index}))
        }
    }

    _moveCallback({slider, current}) {
      
        if(!current.length) return;

        let id = slider.dataset.bstrSliderId;

        for(let th of document.querySelectorAll(`.bstrSlider__thumb--active[data-bstr-slider-for="${id}"]`)){
            th.classList.remove('bstrSlider__thumb--active')
        }

        /* only when thumbnail on bottom and setting turned on (otherwise, make image object-fit: contain and fixed max-height) */
        /*
        if(window.innerWidth <= 767){
            let max = 0;
            for(let c of current){
                let ch = c.target.children[0]
                if(!ch) continue
                if(ch.clientHeight > max) max = ch.clientHeight
            }
            if(max) slider.closest('[data-bstr-ppslider]').style.maxHeight = `${max}px`
        } else {
            slider.closest('[data-bstr-ppslider]').style.maxHeight = null
        }
        */

        for(let th of document.querySelectorAll(`[data-bstr-slider-thumb="${current[0].index}"][data-bstr-slider-for="${id}"]`)){
            th.classList.add('bstrSlider__thumb--active')
        }

        /* document.querySelector(`[data-bstr-slider-thumb="${current[0].index}"][data-bstr-slider-for="${id}"]`).classList.add('bstrSlider__thumb--active') */

    }
}

class BstrSectionSlider extends BstrSlider {
    constructor(props){
        super(props)
    }

    _moveCallback(params){
        for(let {target} of params.previous){
            let slide = target.dataset.type == "bannerSlider" ? target.querySelector('div'): target;
            if(slide.dataset.type == "video") slide.querySelector('video').pause()
            slide.classList.remove('slide__animation')
        }

        for(let {target} of params.current){
            let slide = target.dataset.type == "bannerSlider" ? target.querySelector('div'): target
            if(slide.dataset.type == "video") slide.querySelector('video').play()
            slide.classList.add('slide__animation')
        }
    }
}

class BstrStock{
    constructor({events}){
        this.events = events
        this.stockInterval
        this.initStock()
        this.events.on('booster:content:update', this.initStock.bind(this))
    }

    async initStock() {
        if (this.stockInterval) {
        clearInterval(this.stockInterval);
        }
        let holders = document.querySelectorAll('[data-stock-type]');
        if (!holders.length) {
        return;
        }
        let cookie = bstore.get('bstrStock') || {};
        let managed = [];
        let reduce = parseInt(holders[0].dataset.reduce);
        if (holders[0].dataset.stockType == 'inventory' || cookie['stockInfo'] != holders[0].dataset.stockType) {
        cookie = {
            stockInfo: holders[0].dataset.stockType
        };
        }
        for (let i = 0, maxi = holders.length; i < maxi; ++i) {
        let item = holders[i];
        let stock;
        if (cookie[item.dataset.product]) {
            stock = cookie[item.dataset.product];
            managed.push(item);
        } else {
            if (item.dataset.stockType == 'inventory') {
            stock = item.dataset.stockLeft;
            } else {
            stock = getRandomInt(item.dataset.stockLeft / 10, item.dataset.stockLeft);
            cookie[item.dataset.product] = stock;
            managed.push(item);
            }
        }
        if (item.dataset.stockType == 'inventory') {
            item.closestEl('.amount--left').style.width = getRandomInt(5, 25) + '%';
        } else {
            let width = Math.floor(stock / item.dataset.stockLeft * 100 * 0.25);
            if (width < 5) {
            width = 5;
            }
            item.closestEl('.amount--left').style.width = width + '%';
        }
        item.innerText = stock;
        }
        bstore.set('bstrStock', cookie, 1440);
        if (reduce > 0) {
        var self = this;
        this.stockInterval = setInterval(() => {
            self.stockManagement(managed);
        }, reduce * 1000);
        }
    }
    
    stockManagement(holders) {
        let cookie = bstore.get('bstrStock') || {};
        for (let i = 0, maxi = holders.length; i < maxi; ++i) {
        let item = holders[i];
        let stock = parseInt(item.innerText);
        if (stock > 1) {
            --stock;
        }
        cookie[item.dataset.product] = stock;
        let width = Math.floor(stock / item.dataset.stockLeft * 100 * 0.25);
        if (width < 5) {
            width = 5;
        }
        item.closestEl('.amount--left').style.width = width + '%';
        item.innerText = stock;
        }
        bstore.set('bstrStock', cookie, 1440);
    }  
}

class BstrSwatches {
    constructor({events, slider, cfx}) {
        this.events = events
        this.current = {}
        this.variants = {}
        this.wishlist = new BstrWishList({events})
        this.THEME_UTILS = new BstrSwatchesTheme({swatches: this, events, slider, cfx})
        this.initListeners()
        this.events.on('booster:content:update', ()=>{
            this.initListeners()
            for(let k of Object.keys(this.current)){
                this.filterSwatches(k)
            }
        })
    }

    swatchMaster = [

      /* Gildan G180, G185, G200, G240 */
      'American Red',
      'Ash Gray',
      'Bermuda Sand',
      'Berry Red',
      'Blunt White',
      'Carolina Blue',
      'Carrot Orange',
      'Cursed Black',
      'Desert Grove',
      'Fuel Yellow',
      'Go Green',
      'Patriot Blue',
      'Royal Navy',
      'Sherwood Forest',
      'Urbanite Gray',

      /* Make Market 11.8oz, 12oz, 15oz */
      'Ceramic White',
      'Two Tone',

      /* Q-Tees Q611, Q4350 */
      'Coconut White',
      'Fortress Black',
      'Macaw Red',
      'Reef Blue',
      'Shetland Beige',
      'Victory Blue',

      /* Sportsman SP400 */
      'Cosmic Ocean',
      'Cotton Candy',
      'Dark Pink',
      'Lake Blue',
      'Midnight Raven',
      'Purple Passion',
      'Raspberry Mist',
      'Sky Blue',

      /* Sportsman SP500/SP510 */
      'Black Onyx',
      'Imperial Red',
      'Mountain Stone',
      'Police Blue',
      'Rifle Green',
      'Texas Orange',
      'Turquoise Surf',
      'Wild Cardinal'

    ];

    initListeners(){
        const self = this;
        let swatches = document.querySelectorAll('[data-swatch-index]:not([data-booster-initd])')
        for(let swatch of swatches){
            if(swatch.tagName == 'OPTION') continue
            if(swatch.tagName === 'SELECT'){
                swatch.addEventListener('change', (event)=>{
                    let t = event.currentTarget
                    let v = t.value
                    let pi = t.dataset.swatchIndex.trim().split('-')
                    let swatchOption;
                    if(v === 'bstrSelectNill'){
                        swatchOption = false
                    }else{
                        swatchOption = v
                    }
                    self.setOption(pi[0], false, parseInt(pi[1]), swatchOption)
                })
            }else{
                swatch.addEventListener('click', (event)=>{
                    let t = event.currentTarget
                    if(_settings.swatchLogic != "amazon" && t.classList.contains('swatch--disabled')) return
                    if(_settings.disableSOSwatch && t.dataset.swatchSoldout) return
                    let pi = t.dataset.swatchIndex.trim().split('-')
                    let swatchOption;
                    if(t.classList.contains('swatch--active')){
                        swatchOption = false
                    } else {
                        swatchOption = swatch.dataset.swatchOption
                    }
                  self.setOption(pi[0], false, parseInt(pi[1]), swatchOption)
                })
            }
            swatch.dataset.boosterInitd = 'true'
        }

        if(_settings.preselectSwatch != "false") {

            let variants = document.querySelectorAll('noscript-variants[data-bstr-preselect]:not(data-bstr-initd)')
            let swatches = document.querySelectorAll('noscript-swatches[data-bstr-swatch]');

            if (_settings.preselectSwatch == "firstOptionIndex") {

                let documentURL = new URL(document.URL);
                let paramsColor = documentURL.searchParams.get('color') ? documentURL.searchParams.get('color') : false;
                let paramsScent = documentURL.searchParams.get('scent') ? documentURL.searchParams.get('scent') : false;

                if (swatches.length) {
                    if (paramsColor) {
                        let swatchParse = JSON.parse(swatches[0].innerText.replace(/'/g, '"'));
                        for(let nos of swatches) {
                            let pid = nos.dataset.bstrSwatch;
                            let pre = swatchParse[paramsColor];
                            let   i = 0;
                            let   o = (pre !== undefined) ? this.getVariant(pid, pre).color : false;

                            nos.dataset.bstrInitd = "true"
                            if(Object.keys(this.current).includes(pid)) continue

                            this.setOption(pid, pre, i, o);
                        }
                    }
                    else if (paramsScent) {
                        let swatchParse = JSON.parse(swatches[0].innerText.replace(/'/g, '"'));
                        for(let nos of swatches) {
                            let pid = nos.dataset.bstrSwatch;
                            let pre = swatchParse[paramsScent];
                            let   i = 0;
                            let   o = (pre !== undefined) ? this.getVariant(pid, pre).scent : false;

                            nos.dataset.bstrInitd = "true"
                            if(Object.keys(this.current).includes(pid)) continue

                            this.setOption(pid, pre, i, o);
                        }
                    }
                    else {
                        for(let nos of variants) {
                            let pid = nos.dataset.bstrSwatch;
                            let pre = nos.dataset.bstrPreselect;
                            let   i = 0;

                            nos.dataset.bstrInitd = "true"
                            if(Object.keys(this.current).includes(pid)) continue 

                            if (this.getVariant(pid, pre).color) {
                                let o = this.getVariant(pid, pre).color;
                                this.setOption(pid, pre, i, o);
                                documentURL.searchParams.set('color', o.toLowerCase().replace(' ', '-'));
                                history.replaceState({}, '', documentURL);
                            }

                            if (this.getVariant(pid, pre).scent) {
                                let o = this.getVariant(pid, pre).scent;
                                this.setOption(pid, pre, i, o);
                                documentURL.searchParams.set('scent', o.toLowerCase().replace(' ', '-'));
                                history.replaceState({}, '', documentURL);
                            }
                        }
                    }
                }
                else {
                    for(let nos of variants) {    
                        let pid = nos.dataset.bstrSwatch;
                        let pre = nos.dataset.bstrPreselect;
                        let   i = 0;
                        let   o = this.getVariant(pid, pre).options[0];

                        nos.dataset.bstrInitd = "true"
                        if(Object.keys(this.current).includes(pid)) continue   
    
                        this.setOption(pid, false, i, o);
                    }
                }

            }
            else{

                for(let nos of variants) {
                    let pid = nos.dataset.bstrSwatch;
                    let  id = nos.dataset.bstrPreselect;

                    nos.dataset.bstrInitd = "true"
                    if(Object.keys(this.current).includes(pid)) continue

                    this.setProductVariant(pid, id);
                }

            }

            let url = new URL(document.URL)
            url.searchParams.delete('link-type')
            url.searchParams.delete('variant')
            history.replaceState({}, '', url)

        }
    }

    getVariants(pid){
        if(!this.variants[pid]){
            this.variants[pid] = JSON.parse(document.querySelector(`noscript-variants[data-bstr-swatch="${pid}"]`).innerText)
        }
        return this.variants[pid]
    }

    getVariant(pid, id){
        return this.getVariants(pid)[id]
    }

    findVariant(pid){
        const current = this.current[pid]
        const variants = this.getVariants(pid)
        for(let [k, v] of Object.entries(variants)){
            let f = true
            for(let i = 0; i < current.length; ++i){
                if(current[i] === false) continue
                if(v.options[i] !== current[i]){
                    f = false
                    break
                }
            }
            if(f) return k
        }
        return false
    }

    dropCombination(pid, idx){
        const variants = this.getVariants(pid)
        const v_values = Object.values(variants)
        const current = [...this.current[pid]]
        let aoptions = this.genArray(()=>[], 0, current.length)

        let nidx;
        for(let i = 0; i < current.length; ++i){
            if(current[i] === false || i === idx) continue
            nidx = i
            break
        }

        for(let {options} of v_values){
            if(options[idx] != current[idx]) continue
            for(let j = 0; j < options.length; ++j){
                aoptions[j].push(options[j])
            }
        }

        for(let i = 0; i < aoptions.length; ++i){
            if(i === idx) continue
            if(!aoptions[i].includes(this.current[pid][i])) this.current[pid][i] = false
        }

        if(JSON.stringify(current) === JSON.stringify(this.current[pid])){
            this.current[pid][nidx] = false
            if(!this.findVariant(pid)) return this.dropCombination(pid, idx)
        }
    }

    validateOptions(pid, changeOptions, i){

        let ov = this.findVariant(pid)
        let selected = false
        if(typeof ov !== "boolean"){
            selected = ov
        }

        this.current[pid] = changeOptions
        let mv = this.findVariant(pid)

        if (mv === false) {
            if(_settings.swatchLogic === "amazon"){
                this.dropCombination(pid, i)
            }
            this.events.trigger('booster:swatch:update', {selectedVariant: false, currentOptions: this.current[pid], product: {id: pid, variants: this.getVariants(pid)}})
            if(selected !== false) this.events.trigger('booster:variant:deselect', {oldVariant: selected, currentOptions: this.current[pid], product: {id: pid, variants: this.getVariants(pid)}})
        }
        else {
            if (this.current[pid].includes(false)) {
                this.events.trigger('booster:swatch:update', {selectedVariant: false, currentOptions: this.current[pid], product: {id: pid, variants: this.getVariants(pid)}})
                if(selected !== false) this.events.trigger('booster:variant:deselect', {oldVariant: selected, currentOptions: this.current[pid], product: {id: pid, variants: this.getVariants(pid)}})
            }
            else {
                this.events.trigger('booster:swatch:update', {selectedVariant:this.getVariant(pid, mv), currentOptions: this.current[pid], product: {id: pid, variants: this.getVariants(pid)}})
                this.events.trigger('booster:variant:select', {selectedVariant: this.getVariant(pid, mv), currentOptions: this.current[pid], product: {id: pid, variants: this.getVariants(pid)}})
            }
        }

        this.filterSwatches(pid)

    }

    customGallery(o){

        let galleryImages = document.querySelectorAll('span[data-custom-gallery]')
        if (galleryImages.length) {

            /*  check for desktop resolution  */
            const isDesktop = window.innerWidth >= 1024;
    
            /*  new target swatch  */
            let swatchColor = o.toLowerCase().replace(' ', '-');
            let swatchThumb = '';
            let swatchImage = '';
            let zoomedImage = '';
            let productData = '';
    
            /*  loop through data-bstr-thumb  */
            document.querySelectorAll('img[data-bstr-thumb]').forEach(img => {
                swatchThumb    = img.src;
            if (swatchThumb.includes('no-image')) return;
                swatchThumb    = swatchThumb.split('__');
                swatchThumb[1] = swatchThumb[1].substring(0, swatchThumb[1].lastIndexOf('-'));
                swatchThumb[1] = swatchThumb[1].substring(0, swatchThumb[1].lastIndexOf('-'));
                swatchThumb[2] = swatchThumb[2].split('_');
                swatchThumb[2] = swatchThumb[2][0].substring(0, 4) + '_' + swatchThumb[2][1];
                swatchThumb    = swatchThumb[0] + '__' + swatchThumb[1] + '-' + swatchColor + '__' + swatchThumb[2];

                img.src = swatchThumb;
            });
    
            /*  loop through data-bstr-image  */
            document.querySelectorAll('img[data-bstr-image]').forEach(img => {
                swatchImage    = img.src;
            if (swatchImage.includes('no-image')) return;
                swatchImage    = swatchImage.split('__');
                swatchImage[1] = swatchImage[1].substring(0, swatchImage[1].lastIndexOf('-'));
                swatchImage[1] = swatchImage[1].substring(0, swatchImage[1].lastIndexOf('-'));
                swatchImage[2] = swatchImage[2].split('_');
                swatchImage[2] = swatchImage[2][0].substring(0, 4) + '_' + swatchImage[2][1];
                swatchImage    = swatchImage[0] + '__' + swatchImage[1] + '-' + swatchColor + '__' + swatchImage[2];
    
                img.src = swatchImage;
    
                zoomedImage    = img.getAttribute('data-zoom');
                zoomedImage    = zoomedImage.split('__');
                zoomedImage[1] = zoomedImage[1].substring(0, zoomedImage[1].lastIndexOf('-'));
                zoomedImage[1] = zoomedImage[1].substring(0, zoomedImage[1].lastIndexOf('-'));
                zoomedImage[2] = zoomedImage[2].split('_');
                zoomedImage[2] = zoomedImage[2][0].substring(0, 4) + '_' + zoomedImage[2][1];
                zoomedImage    = zoomedImage[0] + '__' + zoomedImage[1] + '-' + swatchColor + '__' + zoomedImage[2];
    
                if (isDesktop) {
                    $(img).parent().off();
                    $(img).parent().zoom({url: zoomedImage, magnify: 1});
                }
            });

            /*  change tagline color  */
            let customTaglineColor = '';
            let customTaglineQuery = '';
            switch(o) {
                case 'American Red':
                    customTaglineColor = '#dd303f';
                    break;
                case 'Ash Gray':
                    customTaglineColor = '#adadad';
                    break;
                case 'Bermuda Sand':
                    customTaglineColor = '#ccc3ad';
                    break;
                case 'Berry Red':
                    customTaglineColor = '#992d3d';
                    break;
                case 'Blunt White':
                    customTaglineColor = '#2e7880';
                    break;
                case 'Carolina Blue':
                    customTaglineColor = '#7c99d0';
                    break;
                case 'Carrot Orange':
                    customTaglineColor = '#fd7333';
                    break;
                case 'Cursed Black':
                    customTaglineColor = '#000000';
                    break;
                case 'Desert Grove':
                    customTaglineColor = '#6c785a';
                    break;
                case 'Fuel Yellow':
                    customTaglineColor = '#f49d08';
                    break;
                case 'Go Green':
                    customTaglineColor = '#3a9d60';
                    break;
                case 'Patriot Blue':
                    customTaglineColor = '#3053a4';
                    break;
                case 'Royal Navy':
                    customTaglineColor = '#303651';
                    break;
                case 'Sherwood Forest':
                    customTaglineColor = '#283d32';
                    break;
                case 'Urbanite Gray':
                    customTaglineColor = '#585556';
                    break;
            }

                customTaglineQuery = document.querySelector('.product__tagline--desktop');
            if (customTaglineQuery) customTaglineQuery.style.color = customTaglineColor;
                customTaglineQuery = document.querySelector('.product__tagline--mobile');
            if (customTaglineQuery) customTaglineQuery.style.color = customTaglineColor;
    
            /*  update wishlist dataset  */
            let wishlist = document.querySelector(`.wishlist_button`);
            if (wishlist) {

                /*  productUrl  */
                productData = wishlist.dataset.productUrl;
                productData = productData.split('?');
                productData = productData[0] + '?color=' + swatchColor;
                wishlist.setAttribute('data-product-url', productData);

                /*  productImagemain  */
                productData = wishlist.dataset.productImagemain;
            if (productData.includes('no-image')) return;
                productData    = productData.split('__');
                productData[1] = productData[1].substring(0, productData[1].lastIndexOf('-'));
                productData[1] = productData[1].substring(0, productData[1].lastIndexOf('-'));
                productData[2] = productData[2].split('_');
                productData[2] = productData[2][0].substring(0, 4) + '_' + productData[2][1];
                productData    = productData[0] + '__' + productData[1] + '-' + swatchColor + '__' + productData[2];
                wishlist.setAttribute('data-product-imagemain', productData);

                /*  productImagezoom  */
                productData = wishlist.dataset.productImagezoom;
            if (productData.includes('no-image')) return;
                productData    = productData.split('__');
                productData[1] = productData[1].substring(0, productData[1].lastIndexOf('-'));
                productData[1] = productData[1].substring(0, productData[1].lastIndexOf('-'));
                productData[2] = productData[2].split('_');
                productData[2] = productData[2][0].substring(0, 4) + '_' + productData[2][1];
                productData    = productData[0] + '__' + productData[1] + '-' + swatchColor + '__' + productData[2];
                wishlist.setAttribute('data-product-imagezoom', productData);

                this.wishlist.toggle(wishlist);
                this.wishlist.toggle(wishlist);
            }

            let url = new URL(document.URL)
            url.searchParams.set('color', swatchColor)
            history.replaceState({}, '', url)

            let styleStyle = document.querySelectorAll('.shirtstyle__href');
            styleStyle.forEach((e)=>{
                let href = new URL(e.href);
                    href.searchParams.set('color', swatchColor);
                  e.href = href;
            })

            window.scroll({top: 0, behavior: 'smooth'})
          
        }

    }

    setOption(pid, pre, i, o) {

        let changeOptions;
        let swatchOptions;

        if (pre) {
            if (!this.current[pid]) {
                 this.current[pid] = new Array(this.getVariants(pid)[pre].options.length).fill(false)
            }
            changeOptions = [...this.current[pid]]
            swatchOptions = this.getVariants(pid)[pre].options
            for (let j = 0; j < swatchOptions.length; j++) {
                changeOptions[j] = swatchOptions[j]
                if (swatchOptions[j] == o) break;
            }
        }
        else {
            if (!this.current[pid]) {
                 this.current[pid] = new Array(Object.values(this.getVariants(pid))[0].options.length).fill(false)
            }
            changeOptions = [...this.current[pid]]
            swatchOptions = o
            changeOptions[i] = swatchOptions
        }

        this.validateOptions(pid, changeOptions, i)

        if (o) {
          if (this.swatchMaster.includes(o)) {
            this.customGallery(o)
          }
          else {
            /*
            let variantOptions = Object.values(this.getVariants(pid))[0].options;
            for (var i = 0; i < variantOptions.length; i++) {
              if (this.swatchMaster.includes(variantOptions[i])) {
                this.customGallery(variantOptions[i]);
                break;
              }
            }
            */
          }
        }

    }

    setOptions(pid, arr) {
        if (!this.current[pid]) {
            this.current[pid] = new Array(Object.values(this.getVariants(pid))[0].options.length).fill(false)
        }

        this.validateOptions(pid, [...arr], 0)
    }

    setProductVariant(pid, id) {
        const variant = this.getVariant(pid, id)
        this.setOptions(pid, variant.options)
    }

    genArray(gf, s, e){
        let a = []
        for(let i = s; i < e; ++i){
            a[i] = gf.call()
        }
        return a
    }

    matchesOptions(c, options){
        for(let i = 0; i < options.length; ++i){
            if(c[i] === false) continue
            if(c[i] != options[i]) return false
        }
        return true
    }

    filterSwatches(pid) {  

        const variants = this.getVariants(pid)
        const current = this.current[pid]
        let aVars = current.length

        let aOptions = this.genArray(()=>new Set(), 0, aVars)
        for(let v of Object.values(variants)){
            for(let i = 0; i < aVars; ++i){
                aOptions[i].add(v.options[i])
            }
        }

        for(let i = 0; i < current.length; ++i){
            let tOpts = this.genArray(()=>new Set(), 0, aVars)
            let cm = [...current]
            cm[i] = false
            for(let {options} of Object.values(variants)){
                if(this.matchesOptions(cm, options)){
                    for(let j = 0; j < aVars; ++j){
                        tOpts[j].add(options[j])
                    }
                }
            }

            aOptions[i] = new Set([...aOptions[i]].filter(v => tOpts[i].has(v)))
        }

        return this.events.trigger('booster:swatch:render', {pid, options: current, aOptions})
    }
}

class BstrSwatchesTheme{
    constructor({swatches, events, slider, cfx}){
        this.sw = swatches
        this.cfx = cfx
        this.slider = slider
        this.events = events
        this.initEvents()
    }

    initEvents(){
        this.events.on('booster:variant:select', this.selectSwatch.bind(this))
        this.events.on('booster:variant:deselect', this.deselectSwatch.bind(this))
        if(_settings.variantShowImage) this.events.on('booster:swatch:update', this.scrollToImage.bind(this))
        this.events.on('booster:swatch:render', this.renderSwatches.bind(this))
    }

    renderSwatches({pid, options, aOptions}){

        for (let i = 0; i < aOptions.length; ++i) {
            let os = document.querySelectorAll(`[data-swatch-index="${pid}-${i}"]`)
            for (let o of os) {
                if(o.tagName == "OPTION"){
                    if (!aOptions[i].has(o.value)) {
                        o.setAttribute('disabled', 'true')
                    } else {
                        o.removeAttribute('disabled')
                    }
                }else if(o.tagName !== "SELECT"){
                    if (!aOptions[i].has(o.dataset.swatchOption)) {
                        o.classList.add('swatch--disabled')
                    } else {
                        o.classList.remove('swatch--disabled')
                    }
                }
            }
        }

        for(let e of document.querySelectorAll(`.swatch--active[data-swatch-index^="${pid}"]`)){
            e.classList.remove('swatch--active')
        }

        for(let i = 0; i < options.length; ++i){
            if(options[i] === false){
                document.querySelectorAll(`span[data-swatch-selected-name="${pid}-${i}"]`).forEach(e=>e.innerText = '')
                document.querySelectorAll(`select[data-swatch-index="${pid}-${i}"]`).forEach(e=>e.value = 'bstrSelectNill')
            } else {
                document.querySelectorAll(`span[data-swatch-selected-name="${pid}-${i}"]`).forEach(e=>e.innerText = options[i])
            }
        }

        let actives = []
    
        for(let i = 0; i < options.length; ++i){
            if(options[i] === false) continue
            actives.push(...document.querySelectorAll(`[data-swatch-option="${CSS.escape(options[i])}"][data-swatch-index="${pid}-${i}"]`))
            actives.push(...document.querySelectorAll(`option[value="${CSS.escape(options[i])}"][data-swatch-index="${pid}-${i}"]`))
        }

        for(let e of actives){
            if(e.tagName == "OPTION"){
                e.closest('select').value = e.value
            }else{
                e.classList.add('swatch--active')
            }
        }
    }

    scrollToImage(params){
        let queryString = ''
        const initial = params.currentOptions.length
        let marker = new Array(initial * 2).fill('#')
        marker[0] = "|"
        marker[initial * 2 - 1] = "|"
        let operator = new Array(initial).fill('*')
        operator[0] = "^"
        operator[initial - 1] = "$"
        if(params.currentOptions.some((e)=>e !== false)){
            if(!params.currentOptions.includes(false)){
                let qs = ''
                for(let i = 0; i < initial * 2; i += 2){
                    qs += `${marker[i]}${CSS.escape(params.currentOptions[i / 2])}${marker[i + 1]}`
                }
                if(!params.selectedVariant.isCardSwatches) {
                    queryString = `[data-variants*="${qs}"]`.replace(/##/g, '#')
                  } else {
                     queryString = `[data-card-product-id="${params.product.id}"][data-variants*="${qs}"]`.replace(/##/g, '#')
                 }
            } else {
                for(let i = 0; i < initial * 2; i += 2){
                    if(params.currentOptions[i / 2] === false) continue
                    queryString += `[data-variants${operator[i / 2]}="${marker[i]}${CSS.escape(params.currentOptions[i / 2])}${marker[i + 1]}"]`
                }
            }

            let elem = document.querySelector(queryString)
            if(elem){
                let parent = elem.closest('[data-bstr-slide-holder]')
                let index = Array.from(parent.children).indexOf(elem)
                this.slider._moveTo({index, slider: parent})
                this.slider._moveThumbTo({index})
            }
        }
    }

    selectSwatch(params){

        let pid = params.product.id
        let price = params.selectedVariant.price
        let variant = params.selectedVariant
        let elems = document.querySelectorAll(`[data-product-price="${pid}"], [data-product-price-sale="${pid}"]`)

        /* Changes the sku value upon selecting swatch option */
        let skuElem = document.querySelector('.product-page--sku');
        
        if(skuElem && variant.sku) skuElem.innerText = variant.sku

        let sale = variant.sale_raw

        $('.data-product-from').hide();
        elems.forEach((e)=>{
            e.innerHTML = '<strong>' + price + '</strong>';
            if(sale){
                e.classList.add('product__price--sale')
            } else {
                e.classList.remove('product__price--sale')
            }
            e.classList.remove('hide')
        })
        
        document.querySelectorAll(`[data-tag-product="${pid}"]`).forEach((e)=>{
            let type = sale ? e.dataset.tagType : false
            switch(type){
                case 'percent':{
                    e.innerHTML = '<strong>' + Math.abs(Math.floor((variant.price_raw - variant.sale_raw) / variant.sale_raw * 100)) + '% ' + _bstrLocale.tags.off + '</strong>';
                    break;
                }
                case 'amount':{
                    e.innerHTML = '<strong>' + this.cfx.formatMoney(variant.sale_raw - variant.price_raw, this.cfx.getFormat()) + ' ' + _bstrLocale.tags.off + '</strong>';
                    break;
                }
                case 'text':{
                    e.innerHTML = '<strong>' + _bstrLocale.tags.sale.toUpperCase() + '</strong>';
                    break;
                }
                default:{
                    e.classList.add('hide')
                    break;
                }
            }

            if(type) e.classList.remove('hide')
        })

        document.querySelectorAll(`[data-product-price-sale="${pid}"]`).forEach((e)=>{
            let type = e.dataset.productType;
            if (!sale) {
                if (type != 'Gift Cards') {
                    e.innerHTML = 'MSRP: ' + this.cfx.formatMoney(Math.round((variant.price_raw / 0.75) / 50) * 50, this.cfx.getFormat());
                    e.classList.remove('hide');
                }
                else {
                    e.innerHTML = '';
                    e.classList.add('hide')
                }
            }
            else {
                e.innerHTML = 'Reg: ' + variant.sale;
                e.classList.remove('hide');
            }
        })

        let inps = document.querySelectorAll(`input[data-bstr-variant-input="${params.product.id}"]`)
        for(let input of inps){
            input.setAttribute('value', params.selectedVariant.id)
        }

        let buttons = document.querySelectorAll(`[data-buy-button="${params.product.id}"]`)
        for(let btn of buttons){
            if(variant.available){
                btn.querySelector('[data-button-text]').innerHTML = btn.dataset.originalText + ' - <span style="font-family: Montserrat; font-size: 17px;"><strong>' + price + '</strong></span>'
                btn.removeAttribute('disabled')
            } else {
                btn.querySelector('[data-button-text]').innerHTML = _bstrLocale.buttons.sold_out
                btn.setAttribute('disabled', 'true')
            }
        }

        let dynbuttons = document.querySelectorAll(`[data-dynamic-button="${params.product.id}"]`)
        for(let btn of dynbuttons){
            let b = btn.querySelector('button')
            if(!b) continue
            if(variant.available){
                b.removeAttribute('disabled')
            } else {
                b.setAttribute('disabled', 'true')
            }
        }

        if(!params.selectedVariant.isCardSwatches)  {
/*
            let url = new URL(document.URL)
            url.searchParams.set('variant', params.selectedVariant.id)
            history.replaceState({}, '', url)
*/
        } else {
            let productHandleSelector = `[data-product-card-swatch-id='${params.product.id}']`
            let productElem = document.querySelectorAll(productHandleSelector);

            productElem.forEach((e)=>{
                e.href = params.selectedVariant.variant_url
            })
        }

        this.events.trigger('booster:price:update', {elements: elems})
    }

    deselectSwatch(params){

        let inps = document.querySelectorAll(`input[data-bstr-variant-input="${params.product.id}"]`)
        let elems = document.querySelectorAll(`[data-product-price="${params.product.id}"], [data-product-price-sale="${params.product.id}"], [data-tag-product="${params.product.id}"]`)
        let from = document.querySelectorAll(`[data-from-price="${params.product.id}"]`)

        if (from.length) {
            $('.data-product-from').show();
            elems.forEach((e)=>{
                e.classList.add('hide');
            })
        }

        for(let input of inps){
            input.setAttribute('value', -1)
        }

        let buttons = document.querySelectorAll(`[data-buy-button="${params.product.id}"]`)
        for(let btn of buttons){
            btn.setAttribute('disabled', 'true')
            btn.querySelector('[data-button-text]').innerHTML = _bstrLocale.buttons.select
        }

        let dynbuttons = document.querySelectorAll(`[data-dynamic-button="${params.product.id}"]`)
        for(let btn of dynbuttons){
            let b = btn.querySelector('button')
            if(!b) continue
            b.setAttribute('disabled', 'true')
        }

    }

}

class BstrVisitor{
    constructor({events, basync, geo = true}){
        this.events = events
        this.geo = geo
        this.basync = basync
        this.customer = false
        this.map = {
          '%country%': {
            k: 'country',
            sk: 'name'
          },
          '%city%': {
            k: 'city',
            sk: 'name'
          },
          '%zip%': {
            k: 'city',
            sk: 'zip'
          },
          '%flag_svg%': {
            k: 'flag',
            sk: 'svg'
          },
          '%flag_emoji%': {
            k: 'flag',
            sk: 'emoji'
          },
          '%language_name%': {
            k: 'language',
            sk: 'name'
          },
          '%language_native%': {
            k: 'language',
            sk: 'nativeName'
          },
          '%language_code%': {
            k: 'language',
            sk: 'code'
          },
          '%currency_code%': {
            k: 'currency',
            sk: 'code'
          },
          '%currency_name%': {
            k: 'currency',
            sk: 'name'
          },
          '%currency_symbol%': {
            k: 'currency',
            sk: 'symbol'
          }
        }
        this.init()
    }

    replaceContent(block){
      let it = block.dataset.bstrGeoBlock == "" ? block.innerHTML : block.dataset.bstrGeoBlock
      for(let [k, v] of Object.entries(this.map)){
        it = it.replace(new RegExp(k, 'gi'), v.sk ? this.customer[v.k][v.sk] : this.customer[v.k])
      }
      block.innerHTML = it
    }

    embedGeo(){
      let gblock = document.querySelectorAll('[data-bstr-geo-block]:not([data-bstr-initd])')
      for(let block of gblock){
        this.replaceContent(block)
        block.dataset.bstrInitd = "true"
        block.removeAttribute('data-bstr-geo-block')
      }
    }

    async init() {
		if (bstore.get("bstr:visitor_info")) return this.customer = bstore.get("bstr:visitor_info"), this.embedGeo(), this.events.on("booster:content:update", this.embedGeo.bind(this)), this.events.trigger("booster:geo:visitor", this.customer, !0);
/*
        let t = await fetch("https://js.instantgeo.info/json");
    		t.ok || this.events.trigger("booster:geo:error");

		let {
			country: e,
			city: r,
			postalCode: a = "00000",
			ip: o = "0.0.0.0"
		} = (t.ok && t.status === 200) ? await t.json() : {
			country: "US",
			city: "Washington, D.C."
		};
*/
        var e = (typeof e === 'undefined') ? "US" : e;
        var r = (typeof r === 'undefined') ? "Washington, D.C." : r;
        var a = (typeof a === 'undefined') ? "00000" : a;
        var o = (typeof o === 'undefined') ? "0.0.0.0" : o;

        let n = new URL(window.location);
        n.pathname = bstri18n.all_products_route, n.searchParams.set("sort_by", e || "US");

        let {
			json: s
		} = await this.basync.load({
			url: n,
			section: "countries",
			json: "div#countries-json"
		});

        if (!s) return this.events.trigger("booster:geo:error");
		let {
			capital: i,
			region: c,
			name: l,
			nativeName: u,
			currency: m,
			languages: d,
			flag: h,
			emoji: y
		} = s, p = d[0], f = p.iso639_1.toLowerCase();

        switch (e) {
			case "BR":
				f = "pt-br";
				break;
			case "PT":
				f = "pt-pt"
		}

        return this.customer = {
			ip: o,
			country: {
				code: e,
				name: l,
				nativeName: u,
				capital: i
			},
			region: c,
			city: {
				name: r,
				zip: a,
				capital: i.toLowerCase() == r.toLowerCase()
			},
			language: {
				code: f,
				name: p.name,
				nativeName: p.nativeName
			},
			currency: m,
			flag: {
				svg: `<img src="${h}" style="height: 1em">`,
				emoji: y.split(" ").reduce((t, e) => t += String.fromCodePoint(parseInt(e, 16)), "")
			}
		}, bstore.set("bstr:visitor_info", this.customer, 180), this.embedGeo(), this.events.on("booster:content:update", this.embedGeo.bind(this)), this.events.trigger("booster:geo:visitor", this.customer, !0)
	}

    get(){
        return this.customer
    }
}

class BstrBlockLink {
    constructor(){
        this.initBlockLinks()
    }

    initBlockLinks() {
        let blockLinks = document.querySelectorAll('.background_image--link');
        blockLinks.forEach((e)=>{
           e.addEventListener('click', function() {
                let backgroundImageUrl = e.dataset.backgroundImageUrl;
                location.href = backgroundImageUrl;
           })
        })
    }
}

class BstrTheme{
    constructor() {
        this.events = new BstrEvents()
        this.basync = new BstrAsync({events: this.events})
        this.initFeaturedProducts()
        document.dispatchEvent(new CustomEvent('booster:initialized', {detail: {BoosterTheme: this}}))
        this.notify = new BstrNotify({events: this.events})
        this.cart = new BstrCart({events: this.events, basync: this.basync})
        this.lazy = new BstrLazy({events: this.events})
        this.defaultSlider = new BstrSlider({events: this.events})
        this.PPSlider = new ProductSlider({events: this.events, selector: '[data-bstr-ppslider]'})
        this.sectionSlider = new BstrSectionSlider({events: this.events, selector: '[data-bstr-section-slider]'})
        this.cfx = new BstrCurrency({events: this.events})
        this.swatches = new BstrSwatches({events: this.events, slider: this.PPSlider, cfx: this.cfx})
        this.counters = {
            cart: new BstrCntr('[data-bstr-cntr-id^="c-"]'),
            watching: new BstrCntr('[data-bstr-cntr-id^="w-"]')
        }
        this.countdown = new BstrCountdown({events: this.events})
        this.filters = new BstrFilters({events: this.events, basync: this.basync})
        this.insta = BstrDummyClass /* disabled */
        this.visitor = new BstrVisitor({events: this.events, basync: this.basync})
        this.localize = new BstrLocalize({events: this.events, cfx: this.cfx})
        this.freeShippingBar = new BstrFreeShipping({events: this.events, cfx: this.cfx})
        this.inlineUpsell = new BstrIU({events: this.events, cfx: this.cfx, swatches: this.swatches})
        this.ELEMENTS = new BstrElements({events: this.events, basync: this.basync, cart: this.cart, cfx: this.cfx})
        if(_settings.OPDynTitle.trim() != '' || _settings.BPDynTitle.trim() != '') this.dynt = new BstrDynTitle()
        if(_settings.copycat) this.copycat = new BstrCopycat()
        if(_settings.gdpr) this.gdpr = new BstrGDPR()
        if(_settings.recentlyBought && typeof recentlyBoughtConfig !== 'undefined') this.recentlyBought = new BstrRecentlyBought()
        this.optout = new BstrOptOut();
        this.blockLink = new BstrBlockLink();
        this.events.trigger('booster:loaded', {BoosterTheme: this})
    }

    async initFeaturedProducts(){
        try{
            let products = document.querySelectorAll('[data-featured-product]');
            for(let i = 0, maxi = products.length; i < maxi; ++i){
                this.renderFeaturedProduct(products[i]);  
            }
        }catch{}
      }
}

const bstore = new BstrStore();
const BoosterTheme = new BstrTheme()

/*  https://codebeautify.org/minify-js  */